var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.43,191.88a36.18,36.18,0,0,0-15.49-5.33c-2.53-.26-5.3-.19-7.33,1.35a1.51,1.51,0,0,0-.76,1.34,1.69,1.69,0,0,0,.72.91c6.3,4.81,15.84,5.42,22.86,1.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,191.44a74.81,74.81,0,0,1-10-8.8,25.25,25.25,0,0,1-6.28-11.6,4.67,4.67,0,0,1,.5-3.88c8,6.23,14.24,14.28,15.78,24.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.35,191.82a36.26,36.26,0,0,1,.18-13.14,17.8,17.8,0,0,1,7-10.84c1.38,3.23.79,6.94-.19,10.3a50,50,0,0,1-6.93,14.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.17,205.83c-4.75.58-8.88,3.08-12.43,6.29a23.57,23.57,0,0,0-7.11,12.2c4.66-.29,8.61-3.57,11.47-7.25s4.85-7.72,8-11.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.86,208.07a30.66,30.66,0,0,1,3.54-29c2.71,9.62,1.71,20.48-3.54,29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.19,220.37A22.19,22.19,0,0,0,560,232.57c-.26.52-.5,1.19-.14,1.66a1.54,1.54,0,0,0,1.4.41c4.18-.27,7.88-2.78,10.93-5.64s5.71-6.16,9.09-8.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.86,219.7a39.44,39.44,0,0,1-.39-22c.78-2.83,2.08-5.82,4.71-7.15a.87.87,0,0,1,.71-.13.93.93,0,0,1,.46.53,13.38,13.38,0,0,1,1.11,6.32,40.75,40.75,0,0,1-1,6.4c-.83,3.92-1.27,8.12-3.41,11.5a23.56,23.56,0,0,0-1.37,2.52c-.4.86-.41,1.16-.78,1.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.21,223.78c-2-7.71.13-17.05,5-23.37.36-.46.83-1,1.42-.91.89.08,1.12,1.28,1.08,2.17a42.17,42.17,0,0,1-7.48,22.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.68,225.46c9.36,2.44,20.1.07,27.89-5.67a22.55,22.55,0,0,0-15.1-1.85c-5,1.15-9.65,3.41-12.79,7.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.76,220.33c5.24-8.55,15.29-14.13,25.31-14.63-1.15,4.07-4.5,7.24-8.28,9.15s-8,2.75-12.15,3.55c-1.62.32-3.84.66-4.88,1.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.73,195.43c1.42-4.86,2.85-9.77,3.24-14.82s-.33-10.33-3-14.67c-4.9,9.48-5.4,20.56-.43,30",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.22,187.1c5.73-10.41,17.42-18.73,29.24-19.89-4.56,11.35-17,20.13-29.24,19.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.62,189.14c8.54,1.3,15.82,6.76,23.8,10.06a10.66,10.66,0,0,0,5.39,1,4.21,4.21,0,0,0,2.63-7.45,11.4,11.4,0,0,0-3.91-2.37c-8.69-3.62-18-3.71-27.17-1.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.68,195.13c1.93.55,2.59,1.55,4.12,2.86a44.55,44.55,0,0,0,18.05,9.27c.69.17,1.6.24,1.94-.38s-.08-1.2-.47-1.69a24.81,24.81,0,0,0-10.9-7.4c-4.16-1.55-7.77-3.42-12.74-3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.1,158.94a34.14,34.14,0,0,0,26.19,8.91,1.77,1.77,0,0,0,1.19-.43c.66-.71-.13-1.82-.9-2.42-7.7-6-17-8.49-26.48-6.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.71,156.52a36.51,36.51,0,0,1,32.68-5.39A26,26,0,0,1,634.82,158a49.4,49.4,0,0,1-17.11-1.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.08,139.89c-.75-7.68-.26-13.75-.8-21.47,0-.62-.17-1.36-.75-1.58-.8-.31-1.47.67-1.74,1.49a24.66,24.66,0,0,0,3.28,21.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.53,140.74a45.16,45.16,0,0,0,12.73-12.37c2.52-3.44,4.64-7.57,4.07-11.79a12.2,12.2,0,0,0-9.19,4.56,25.57,25.57,0,0,0-4.68,9.42c-1,3.38-1.73,6.86-2.93,10.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627,137.27a102.65,102.65,0,0,0,31.33-18.48c-3.74-1.51-8-.61-11.77.91-8.55,3.45-15.53,9.27-19.72,17.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.05,145c5.78.63,11.66,1,17.4.08s11-3.18,16.24-5.4a1.9,1.9,0,0,0,1.1-.83,1.26,1.26,0,0,0-.39-1.39,3.36,3.36,0,0,0-1.39-.65c-5.73-1.61-11.91-.86-17.55,1.05A81.3,81.3,0,0,0,618.05,145",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585,159.2c-3.95-8-3.69-17.26-.28-25.47,2.4,3.66,2.69,8.32,2.25,12.67s-1.76,8.83-1.85,13.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.26,151.25a35.53,35.53,0,0,0-26.4,11.25c4.92.77,10-.5,14.45-2.68a73.77,73.77,0,0,0,12.39-8.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.66,147.71c-4.82-.39-9.46-1-14.09.43s-8.86,4.64-10.75,9.11a25.42,25.42,0,0,0,13.22-2.5,75.69,75.69,0,0,0,11.62-7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.35,147.87c-4.34-2.84-8.79-5.73-13.84-6.91s-10.9-.31-14.42,3.5c4.09,2.4,9,2.68,13.79,2.68s10.54-.06,15,1.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.38,148.1c-7.42-7.28-10.23-20.36-7.25-30.31a46.22,46.22,0,0,1,7.25,30.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.76,127.48c1.4-3.25,2.38-6.67,3.63-10a28.68,28.68,0,0,1,5.19-9.19,13.62,13.62,0,0,1,9.18-4.76,37,37,0,0,1-17.82,24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.07,131.77c-2.31-3.18-5-7.5-8.12-9.88s-7.23-3.82-11.05-2.9a25.73,25.73,0,0,0,19.17,12.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.81,127.74a54.62,54.62,0,0,1-3.66-11.84c-.61-4.1-.24-8.47,1.86-12,4.06,7.69,5.37,15.94,2,24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.8,103.86c2.3-7.63,9.28-13.24,16.82-15.82a6.26,6.26,0,0,1,3-.44,2.57,2.57,0,0,1,2.18,1.81c.27,1.3-.8,2.46-1.81,3.32a57.4,57.4,0,0,1-20.14,11.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.88,97.62c.29-4.92.6-9.9,2.2-14.56s4.68-9,9.16-11.07c.77,5-1.43,9.91-4.07,14.18s-5.82,8.31-7.41,13.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.76,101c-1.91-5.55-2.1-12.61-5.43-17.45-2.33-3.39-6.05-5.69-8.06-9.28a14.13,14.13,0,0,0,.47,10.53,30.71,30.71,0,0,0,6.16,8.81c2.46,2.63,4.57,4.61,6.86,7.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.8,264.66c-.15,0-.28-37.08-.29-82.79s.1-82.8.25-82.8.28,37.06.29,82.8S594.94,264.66,594.8,264.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.19,153.61a7.18,7.18,0,0,1-1.39.52l-3.84,1.3c-3.23,1.1-7.67,2.69-12.5,4.67s-9.27,3.71-11.84,5.93a8.75,8.75,0,0,0-2.38,3.15c-.37.87-.43,1.41-.48,1.4a1.19,1.19,0,0,1,0-.39,6.16,6.16,0,0,1,.28-1.08,8.23,8.23,0,0,1,2.32-3.36,20.89,20.89,0,0,1,5.14-3.19c2-1,4.33-2,6.75-2.95,4.84-2,9.31-3.53,12.59-4.54,1.63-.51,3-.89,3.89-1.14A7.35,7.35,0,0,1,627.19,153.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.81,127.53a2.64,2.64,0,0,1-.39.41l-1.19,1.12-4.44,4L617,146.26c-5.77,5.13-10.76,10-14.21,13.73-1.73,1.85-3.1,3.38-4,4.45-.43.49-.78.9-1.07,1.22a2.71,2.71,0,0,1-.4.41,2.19,2.19,0,0,1,.32-.48c.22-.29.55-.74,1-1.29.89-1.11,2.21-2.68,3.91-4.56a185.71,185.71,0,0,1,14.13-13.88c5.79-5.13,11.06-9.73,14.89-13.05l4.55-3.9,1.26-1A2,2,0,0,1,637.81,127.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.78,151.48c-.15-.07,1.05-2.85,2.26-6.37s1.78-6.49,1.93-6.47a21.61,21.61,0,0,1-1.43,6.64,43.49,43.49,0,0,1-1.79,4.46A6.85,6.85,0,0,1,610.78,151.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.83,173.92a7.23,7.23,0,0,1-.89-1L591.66,170c-1.91-2.47-4.55-5.88-7.52-9.62s-5.69-7.09-7.66-9.51c-.94-1.15-1.72-2.12-2.33-2.88a7.76,7.76,0,0,1-.81-1.1,6.36,6.36,0,0,1,1,1c.59.65,1.43,1.59,2.46,2.78,2.05,2.36,4.82,5.68,7.79,9.42s5.57,7.19,7.41,9.73c.92,1.26,1.65,2.3,2.14,3A6.62,6.62,0,0,1,594.83,173.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.73,164.8a13,13,0,0,1-3-5.57,16,16,0,0,1-.67-5.62l.23,0c-.1.43-.18.66-.22.65s-.05-.25,0-.69l.23,0a25.84,25.84,0,0,0,1,5.46A41,41,0,0,0,587.73,164.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.56,153.26a10,10,0,0,0-2.08-1.2,13.79,13.79,0,0,0-5.77-.46,36.08,36.08,0,0,0-5.81.93,17.71,17.71,0,0,1-2.39.58,8.06,8.06,0,0,1,2.29-.94,26.34,26.34,0,0,1,5.87-1.11,12.62,12.62,0,0,1,6,.64A3.76,3.76,0,0,1,578.56,153.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.38,150.47c0,.08-1.21-.49-3.18-1.16a32.8,32.8,0,0,0-7.94-1.64,33.22,33.22,0,0,0-8.1.41c-2,.37-3.29.76-3.32.67a3,3,0,0,1,.84-.36,20.21,20.21,0,0,1,2.41-.68A28.38,28.38,0,0,1,573.33,149a21.6,21.6,0,0,1,2.27,1C576.12,150.26,576.4,150.43,576.38,150.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.76,138.64a66.6,66.6,0,0,1-2.32-8.06,64.25,64.25,0,0,1-1.8-8.19,66.6,66.6,0,0,1,2.32,8.06A66.4,66.4,0,0,1,594.76,138.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.91,138.64a39.13,39.13,0,0,0-2.58-4.82,20.89,20.89,0,0,0-3.78-3.91,3.44,3.44,0,0,1,1.46.75,11.78,11.78,0,0,1,2.76,2.85A10.79,10.79,0,0,1,594.91,138.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.8,244.89c-.06,0-.17-.89-.59-2.46a34.51,34.51,0,0,0-2.48-6.42c-2.56-5.23-7.22-11.87-13.14-18.52-2.93-3.35-5.78-6.51-8.2-9.54a66.43,66.43,0,0,1-5.86-8.46,40.68,40.68,0,0,1-3-6.27c-.27-.77-.47-1.38-.58-1.79a2.67,2.67,0,0,1-.15-.64s.32.84.93,2.36a45.36,45.36,0,0,0,3.09,6.15,69.94,69.94,0,0,0,5.92,8.34c2.42,3,5.27,6.14,8.21,9.5,5.94,6.67,10.59,13.39,13.09,18.71a31.85,31.85,0,0,1,2.33,6.53,15.87,15.87,0,0,1,.33,1.86A3.54,3.54,0,0,1,594.8,244.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.07,211.83a13.39,13.39,0,0,1-1.53.86,32.25,32.25,0,0,0-4,2.63,45.88,45.88,0,0,0-5.23,4.77c-1.83,1.94-3.72,4.19-5.65,6.6-3.86,4.83-7.46,9.12-9.62,12.53-1.1,1.7-1.9,3.13-2.42,4.13a13.51,13.51,0,0,1-.84,1.54,1.38,1.38,0,0,1,.14-.43c.11-.28.27-.69.51-1.2a38,38,0,0,1,2.29-4.24c2.09-3.5,5.67-7.84,9.52-12.67,1.93-2.41,3.84-4.67,5.71-6.6a42.18,42.18,0,0,1,5.36-4.73,28.22,28.22,0,0,1,4.11-2.51,12.65,12.65,0,0,1,1.2-.53C623.91,211.86,624.06,211.81,624.07,211.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.64,222.56a25.49,25.49,0,0,1-3.24.47,42.15,42.15,0,0,0-7.69,1.51,23.23,23.23,0,0,0-6.89,3.62c-1.58,1.22-2.33,2.24-2.41,2.18a2.59,2.59,0,0,1,.48-.75,13.06,13.06,0,0,1,1.69-1.73,21,21,0,0,1,7-3.83,34.73,34.73,0,0,1,7.81-1.38A17.19,17.19,0,0,1,624.64,222.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.36,229.16c-.17-.1,1.29-2.33,2.43-5.33s1.31-5.69,1.5-5.66a5.06,5.06,0,0,1,0,1.74,19,19,0,0,1-1,4.1,19.79,19.79,0,0,1-1.88,3.76A5.31,5.31,0,0,1,605.36,229.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.55,183a2.29,2.29,0,0,1-.52.28l-1.52.69c-.67.29-1.48.65-2.39,1.13s-2,1-3.1,1.63l-1.77,1c-.61.36-1.22.78-1.87,1.18-1.3.79-2.61,1.77-4,2.76a68.77,68.77,0,0,0-15.43,16c-.94,1.43-1.87,2.77-2.62,4.1-.38.66-.78,1.28-1.11,1.9l-.94,1.81c-.63,1.13-1.08,2.22-1.53,3.15s-.78,1.75-1,2.43l-.64,1.54a2.35,2.35,0,0,1-.26.53,2.62,2.62,0,0,1,.15-.56c.15-.42.33-.95.55-1.59s.54-1.53,1-2.47.85-2.05,1.46-3.2c.29-.59.6-1.2.92-1.83s.71-1.27,1.09-1.94c.73-1.34,1.65-2.7,2.6-4.15a73.15,73.15,0,0,1,7.08-8.7,73.91,73.91,0,0,1,8.45-7.38c1.42-1,2.74-2,4.07-2.74.65-.39,1.27-.81,1.89-1.15l1.8-1c1.13-.65,2.22-1.12,3.15-1.57a26.3,26.3,0,0,1,2.44-1.05l1.56-.6A2,2,0,0,1,633.55,183Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.38,198.55a3.81,3.81,0,0,1,1.28-1.89,8,8,0,0,1,5.13-2,14,14,0,0,1,5.4,1.05,7.33,7.33,0,0,1,2,1,13,13,0,0,1-2.16-.64,16.61,16.61,0,0,0-5.26-.88,8.47,8.47,0,0,0-4.91,1.72A17.65,17.65,0,0,0,610.38,198.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.92,202.13a19.52,19.52,0,0,0,1.46-4.74,19.18,19.18,0,0,0-.33-4.95c.06,0,.35.47.6,1.38a9.74,9.74,0,0,1-.83,7.1C607.37,201.74,607,202.16,606.92,202.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.19,250.21c.8,14.16,5.07,28.57,11.64,43.14h28.55c6.26-14.42,10.24-28.81,11-43.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.7,273.13c0,.15-9.4.27-21,.27s-21-.12-21-.27,9.4-.27,21-.27S615.7,273,615.7,273.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.06,278.26c0,.15-8.81.27-19.68.27s-19.69-.12-19.69-.27,8.81-.27,19.69-.27S615.06,278.11,615.06,278.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.29,259.51a40.07,40.07,0,0,1,.27,6.57,40.15,40.15,0,0,1-.27,6.58,40.15,40.15,0,0,1-.27-6.58A40.07,40.07,0,0,1,581.29,259.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.59,259.51a43.06,43.06,0,0,1,.27,6.81,43.06,43.06,0,0,1-.27,6.81,43.06,43.06,0,0,1-.27-6.81A43.06,43.06,0,0,1,596.59,259.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,259.39a44.81,44.81,0,0,1,.27,6.95,44.81,44.81,0,0,1-.27,7,44.81,44.81,0,0,1-.27-7A44.81,44.81,0,0,1,611,259.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.42,259.51c0,.15-11,.27-24.63.27s-24.63-.12-24.63-.27,11-.27,24.63-.27S619.42,259.36,619.42,259.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.2 38.95 210.2 116.16 99.31 116.16 95.31 39.49 210.2 38.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.51,
    y: 22.3,
    width: 76.5,
    height: 110.89,
    transform: "translate(73.01 228.51) rotate(-90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.73,116.53H94.79V39H206.73ZM95.84,115.47H205.68V40H95.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 49,
    width: 86.87,
    height: 57.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.19,49h-.42l-1.24,0-4.77,0-17.9.07-62.54.12.25-.25c0,17.57,0,37,0,57.49h0l-.28-.27,86.87.06-.21.21c0-17.49.08-31.84.11-41.83,0-5,0-8.89.06-11.57,0-1.32,0-2.33,0-3s0-1,0-1,0,.33,0,1,0,1.69,0,3c0,2.66,0,6.54.06,11.52,0,10,.06,24.41.11,42v.22h-.22l-86.87.06h-.27v-.28h0c0-20.46,0-39.92,0-57.49v-.25h.25l62.7.12,17.85.07,4.72,0h1.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31,39.28a9.66,9.66,0,0,1,1.91,1.23c1.13.82,2.68,2,4.35,3.32s3.13,2.6,4.17,3.54A8.73,8.73,0,0,1,107.32,49c-.1.12-2.77-2.08-6.1-4.74A63.27,63.27,0,0,1,95.31,39.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2,39.49a52.48,52.48,0,0,1-5.83,5A52.55,52.55,0,0,1,194.19,49,54.54,54.54,0,0,1,200,44,56,56,0,0,1,206.2,39.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,116l-12.37-10",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.75,106a57.28,57.28,0,0,1,6.36,4.8,58.16,58.16,0,0,1,6,5.22,57.28,57.28,0,0,1-6.36-4.8A58.16,58.16,0,0,1,193.75,106Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31,116a52.75,52.75,0,0,1,5.78-4.92,53.11,53.11,0,0,1,6.11-4.48,52.5,52.5,0,0,1-5.77,4.91A52.12,52.12,0,0,1,95.31,116Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.67,
    y: 49.21,
    width: 19.25,
    height: 54.66,
    transform: "translate(75.75 228.83) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.46,
    cy: 387.94,
    rx: 345.06,
    ry: 86.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.35,463.48c-83.64,0-162.28-7.84-221.44-22.09-59.36-14.29-92-33.39-92-53.77s32.69-39.49,92.05-53.78c59.16-14.24,137.8-22.09,221.44-22.09s162.28,7.85,221.43,22.09c59.37,14.29,92.06,33.39,92.06,53.78s-32.69,39.48-92.06,53.77C538.63,455.64,460,463.48,376.35,463.48Zm0-150.73c-172.31,0-312.49,33.58-312.49,74.87S204,462.48,376.35,462.48s312.49-33.58,312.49-74.86S548.66,312.75,376.35,312.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.27,438.05c-69.74,0-135.3-5.74-184.63-16.17-49.54-10.48-76.83-24.52-76.83-39.52s27.29-29,76.83-39.51c49.33-10.43,114.89-16.18,184.63-16.18s135.31,5.75,184.63,16.18c49.54,10.48,76.83,24.51,76.83,39.51s-27.29,29-76.83,39.52C504.58,432.31,439,438.05,369.27,438.05Zm0-110.38c-143.61,0-260.46,24.54-260.46,54.69s116.85,54.69,260.46,54.69,260.46-24.53,260.46-54.69S512.89,327.67,369.27,327.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.27,421.43c-52.35,0-101.58-4.32-138.61-12.15-37.26-7.88-57.77-18.45-57.77-29.78s20.51-21.9,57.77-29.78c37-7.83,86.26-12.15,138.61-12.15s101.59,4.32,138.62,12.15c37.25,7.88,57.77,18.45,57.77,29.78s-20.52,21.9-57.77,29.78C470.86,417.11,421.63,421.43,369.27,421.43Zm0-82.86c-107.73,0-195.38,18.36-195.38,40.93s87.65,40.93,195.38,40.93,195.39-18.36,195.39-40.93S477,338.57,369.27,338.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.25,410.61c-36.73,0-71.26-3-97.24-8.52-26.19-5.54-40.62-13-40.62-21s14.43-15.49,40.62-21c26-5.49,60.51-8.51,97.24-8.51s71.25,3,97.23,8.51c26.2,5.55,40.63,13,40.63,21s-14.43,15.49-40.63,21C431.5,407.58,397,410.61,360.25,410.61Zm0-58.1c-36.66,0-71.12,3-97,8.49-25.31,5.36-39.83,12.67-39.83,20.06s14.52,14.69,39.83,20.05c25.91,5.48,60.37,8.5,97,8.5s71.11-3,97-8.5c25.32-5.36,39.84-12.67,39.84-20.05s-14.52-14.7-39.84-20.06C431.36,355.52,396.9,352.51,360.25,352.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.45,
    y: 185.93,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.53,212.35a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.53,0-2.23-.05-5.42-.08-9.45l.15.15-48.65.1c.11-.11-.25.25.24-.25h0v12.86l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26a.94.94,0,0,1-.23,0h-.69l-2.72,0-10.17.07-34.84.11h-.25V199.49h0c.49-.49.14-.13.25-.25l48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.54,0,1.06,0,1.9,0,2.5,0,.26,0,.46,0,.63A1.23,1.23,0,0,1,194.53,212.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.99,
    y: 63.2,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.07,89.63a2.07,2.07,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.54,0-2.22,0-5.41-.09-9.44l.15.15-48.65.1c.11-.11-.25.24.25-.25h0V83.3c0,2.15,0,4.26,0,6.33l-.24-.24,34.67.11,10.24.07,2.76,0,.73,0h.25s-.07,0-.22,0h-.7l-2.71,0-10.18.07-34.84.11h-.24v-.24q0-3.1,0-6.33V76.78h0l.25-.25,48.65.1h.16v.15c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.91,0,2.5,0,.26,0,.47,0,.64S688.08,89.64,688.07,89.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.55,
    y: 192.57,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.63,219a1.35,1.35,0,0,1,0-.24v-.66c0-.6,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.44l.15.15-48.65.09.24-.24h0V219l-.25-.25,34.68.11,10.23.07,2.77,0h.72l.26,0h-.23l-.69,0-2.72,0-10.18.07-34.84.11h-.24V206.15h0l.25-.25,48.65.09h.15v.15c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A1.66,1.66,0,0,1,445.63,219Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77,127s0-.08,0-.23l0-.66c0-.61,0-1.45,0-2.54,0-2.22,0-5.41-.08-9.44l.15.15-48.65.1c.11-.11-.25.24.25-.25h0v3.27c0,1.09,0,2.17,0,3.25V127l-.24-.24,34.67.11L458,127l2.77,0h.72l.26,0-.22,0h-.7l-2.71,0-10.18.07-34.84.11h-.24V127q0-3.1,0-6.33v-6.52h0l.25-.25,48.65.1h.15v.15c0,4.06-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.64S461.78,127,461.77,127Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.14,133.1a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.53,0-2.22,0-5.42-.08-9.45l.15.15-48.65.1c.11-.11-.25.25.24-.25h0V133.1l-.25-.24,34.68.11,10.23.07,2.77,0,.72,0h.26a.94.94,0,0,1-.23,0l-.69,0-2.72,0-10.18.07-34.84.11h-.24V120.24h0c.49-.49.14-.13.25-.24l48.65.09h.15v.15c0,4.07-.07,7.29-.09,9.54,0,1.07,0,1.9,0,2.5,0,.26,0,.46,0,.63A1.23,1.23,0,0,1,78.14,133.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.66,183.83a1,1,0,0,1,0-.23l0-.66c0-.6,0-1.45,0-2.53,0-2.22-.05-5.42-.09-9.45l.16.15-48.65.1c.11-.11-.25.25.24-.25h0v12.86l-.25-.24,34.67.11,10.24.07,2.77,0,.72,0h.26a.6.6,0,0,1-.23,0l-.69,0-2.72,0-10.18.07-34.84.11h-.24V171h0c.49-.49.13-.13.25-.24l48.65.09h.15V171c0,4.07-.07,7.29-.09,9.54,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A1.23,1.23,0,0,1,715.66,183.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.79,47.66s0-.08,0-.23,0-.38,0-.65c0-.6,0-1.43,0-2.49,0-2.19,0-5.33-.08-9.28l.15.14-48.27.1.24-.24h0v6.4c0,2.12,0,4.19,0,6.23l-.24-.24,34.41.11,10.15.07,2.75,0h.72l.25,0h-.22l-.69,0-2.69,0-10.1.07-34.58.11h-.24V35h0l.25-.25,48.27.1h.15V35c0,4-.06,7.16-.08,9.37,0,1,0,1.87,0,2.45,0,.26,0,.46,0,.63A.8.8,0,0,1,556.79,47.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.93,69.39a1.35,1.35,0,0,1,0-.24v-.66c0-.6,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.45l.15.15-48.65.1c.11-.11-.25.25.24-.25h0V69.39l-.25-.25,34.68.11,10.23.07,2.77,0,.72,0a.87.87,0,0,1,.26,0h-.23l-.69,0-2.72,0-10.18.07-34.84.11H306V56.52h0c.49-.49.14-.13.25-.24l48.65.09h.15v.15c0,4.07-.07,7.29-.09,9.54,0,1.07,0,1.9,0,2.5l0,.63A1.66,1.66,0,0,1,354.93,69.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.52,56.51s0-.08,0-.24,0-.41,0-.68c0-.64,0-1.5-.05-2.58,0-2.26-.06-5.45-.1-9.37l.18.18-29.23.07.25-.25h0v6.62q0,3.24,0,6.24l-.24-.23,20.91.11,6.09.07,1.65,0a3.94,3.94,0,0,1,.58,0,3.28,3.28,0,0,1-.53,0l-1.59,0-6,.07-21.07.11h-.23V50.27c0-1.07,0-2.17,0-3.27V43.65h0c-.05.06.47-.47.25-.24l29.23.06h.18v.17c0,4-.07,7.19-.09,9.47,0,1.07,0,1.92-.05,2.55A4.69,4.69,0,0,1,361.52,56.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.58,432.16c-10.77-10.39-24.44-21-42.12-22a68.07,68.07,0,0,0-21.12,2.6c-20.37,5.33-38.21,15.71-50.1,29-2,2.23-1.59,5.16.92,7.07A189.7,189.7,0,0,0,118.91,463c9,5,19.53,8.75,30.74,9.3,10.49.52,21-1.81,30.3-5.39s17.7-8.35,26-13.11c4.37-2.5,9-5.36,10-9.37C217.1,440,213.3,435.75,209.58,432.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.86,441.84l-.27.2-.81.55c-.72.48-1.77,1.2-3.18,2a115.35,115.35,0,0,1-12.26,6.51c-10.63,5-26.07,10.17-43.58,13.89a58,58,0,0,1-6.58,1,51.74,51.74,0,0,1-6.46.09,55.08,55.08,0,0,1-12-2.06,68.44,68.44,0,0,1-18.65-8.66,135,135,0,0,1-11.19-8.21l-2.93-2.39-.74-.63L96,443.9s.1.05.28.18l.78.6,3,2.31c2.6,2,6.34,4.92,11.27,8.06a69.52,69.52,0,0,0,18.58,8.51,55.49,55.49,0,0,0,11.91,2,48.87,48.87,0,0,0,6.39-.1,59.58,59.58,0,0,0,6.52-1c17.46-3.71,32.89-8.84,43.52-13.72a124.28,124.28,0,0,0,12.32-6.35c1.42-.8,2.49-1.5,3.22-1.95l.84-.51A1.08,1.08,0,0,1,214.86,441.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.78,434.57c-9.22-7.63-20.91-15.39-36-16.14a68,68,0,0,0-18.07,1.91c-17.42,3.92-32.69,11.54-42.86,21.31-1.7,1.64-1.36,3.79.8,5.19a165.74,165.74,0,0,0,18.6,10.38,68.1,68.1,0,0,0,26.3,6.83,74.08,74.08,0,0,0,25.91-3.95c8-2.63,15.15-6.14,22.26-9.64,3.73-1.83,7.73-3.93,8.58-6.87C661.21,440.32,658,437.21,654.78,434.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.29,441.68a2.11,2.11,0,0,1-.23.16l-.71.42c-.63.36-1.54.9-2.77,1.53A103.15,103.15,0,0,1,645,448.62c-9.13,3.68-22.24,7.43-37,10.14a50.47,50.47,0,0,1-10.94.8,53.11,53.11,0,0,1-10.12-1.4,63.22,63.22,0,0,1-16.07-6.28,113.69,113.69,0,0,1-9.85-6.2l-2.58-1.82-.66-.49c-.15-.11-.23-.17-.22-.18a1.15,1.15,0,0,1,.25.14l.69.44,2.63,1.74c2.3,1.5,5.6,3.72,9.92,6a63.88,63.88,0,0,0,16,6.14,50.58,50.58,0,0,0,20.86.56,211,211,0,0,0,36.94-10c4.58-1.76,8.18-3.44,10.63-4.67,1.23-.6,2.17-1.11,2.81-1.45l.73-.37A1,1,0,0,1,659.29,441.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.41,294.7c0,.14-160,.26-357.39.26s-357.43-.12-357.43-.26,160-.26,357.43-.26S732.41,294.56,732.41,294.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.43,218.28l-2.29-7.67a26.65,26.65,0,1,0-6.39,7.12h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.43,218.28h-.54l-1.64-.08-6.52-.34a.11.11,0,0,1-.11-.12.11.11,0,0,1,0-.06h0l.17.16a26.72,26.72,0,0,1-12,5.31,26.44,26.44,0,0,1-8.57,0,26.75,26.75,0,0,1-9.15-3.18,26.86,26.86,0,0,1-6.91-41,26.59,26.59,0,0,1,10.64-7.43,27.5,27.5,0,0,1,12.29-1.66,26.74,26.74,0,0,1,11.06,3.68,26.89,26.89,0,0,1,13.06,24.65,26.68,26.68,0,0,1-4,12.47v-.09c.71,2.5,1.27,4.43,1.65,5.76.17.62.31,1.11.41,1.46a4,4,0,0,1,.12.48l-.17-.51c-.11-.36-.27-.85-.47-1.48-.4-1.31-1-3.2-1.76-5.65a.1.1,0,0,1,0-.09A26.53,26.53,0,0,0,615.91,174a26.28,26.28,0,0,0-10.86-3.58A26.73,26.73,0,0,0,593,172a26.12,26.12,0,0,0-10.42,7.28,26.41,26.41,0,0,0,15.71,43.44,26.05,26.05,0,0,0,8.45,0,26.61,26.61,0,0,0,11.93-5.15.12.12,0,0,1,.17.17h0l-.09-.19,6.43.47,1.68.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.92,196.64a2.71,2.71,0,1,1-2.71-2.7A2.71,2.71,0,0,1,594.92,196.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.76,196.64a2.71,2.71,0,1,1-2.71-2.7A2.71,2.71,0,0,1,605.76,196.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.57,195.29a2.71,2.71,0,1,1-3.7-1A2.72,2.72,0,0,1,616.57,195.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.58,126.59l8,.38a26.69,26.69,0,1,0-4.6-8.39h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.58,126.59l.19-.5.62-1.53c.57-1.39,1.4-3.41,2.47-6a.12.12,0,0,1,.15-.06.15.15,0,0,1,.06,0v0l-.21.1a26.43,26.43,0,0,1,1.78-21.2,26.53,26.53,0,0,1,6-7.57,26.84,26.84,0,0,1,41,7.05,26.48,26.48,0,0,1,3.48,12.5,27.25,27.25,0,0,1-2.5,12.14,26.79,26.79,0,0,1-45.16,5.5l.08,0-6-.35-1.52-.09a4.05,4.05,0,0,1-.49,0h.54l1.55.05,5.91.21a.12.12,0,0,1,.08,0,26.54,26.54,0,0,0,44.53-5.58,26.93,26.93,0,0,0,2.43-11.91,26.08,26.08,0,0,0-3.42-12.25,26.44,26.44,0,0,0-40.22-7,26.1,26.1,0,0,0-6,7.43,25.82,25.82,0,0,0-2.82,8,26.64,26.64,0,0,0,.9,13,.12.12,0,0,1-.07.15.11.11,0,0,1-.14,0h0l.21,0c-1.12,2.57-2,4.55-2.58,5.91l-.67,1.54C335.67,126.41,335.58,126.59,335.58,126.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,110.16a2.71,2.71,0,1,1-2.71-2.71A2.71,2.71,0,0,1,356.83,110.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.67,110.16a2.71,2.71,0,1,1-2.71-2.71A2.71,2.71,0,0,1,367.67,110.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.48,108.8a2.71,2.71,0,1,1-3.7-1A2.72,2.72,0,0,1,378.48,108.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.27,164.58a26.72,26.72,0,0,0,35.26,14.28,27.33,27.33,0,0,0,14.1-35.72,26.73,26.73,0,0,0-35.26-14.28A27.34,27.34,0,0,0,134.27,164.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,183.32a7.53,7.53,0,0,1,.8-.08,3.55,3.55,0,0,1,2,.64,3.47,3.47,0,0,1,1,1.1,3,3,0,0,1,.38,1.65,3.46,3.46,0,0,1-2.13,3,3.38,3.38,0,0,1-3.55-1,3.07,3.07,0,0,1-.75-1.52,3.5,3.5,0,0,1,.09-1.49,3.63,3.63,0,0,1,1.17-1.82,5.84,5.84,0,0,1,.67-.45s-.07,0-.2.07a1.22,1.22,0,0,0-.24.11,2,2,0,0,0-.29.19,3.62,3.62,0,0,0-1.28,1.85,3.56,3.56,0,0,0-.12,1.58,3.2,3.2,0,0,0,.78,1.64,3.72,3.72,0,0,0,1.68,1.07,3.23,3.23,0,0,0,3.78-1.38,3.73,3.73,0,0,0,.62-1.91,3.26,3.26,0,0,0-.43-1.77,3.38,3.38,0,0,0-1.09-1.13,3.45,3.45,0,0,0-2.14-.6,1.69,1.69,0,0,0-.35,0l-.25.06C140.56,183.28,140.49,183.31,140.5,183.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,166.6s-.05-.14-.17-.41l-.53-1.18-.39-.88c-.13-.33-.24-.7-.38-1.09s-.27-.83-.43-1.28a5.42,5.42,0,0,1-.19-.72l-.18-.77a26.41,26.41,0,0,1-.69-7.85,27.68,27.68,0,0,1,2.52-10.09l.63-1.33c.23-.43.5-.86.76-1.29l.39-.66a5.42,5.42,0,0,1,.42-.64q.45-.63.93-1.26l.47-.64.53-.6c.36-.4.73-.8,1.09-1.21s.8-.74,1.21-1.13l.62-.56.31-.28.34-.25a23.69,23.69,0,0,1,2.83-2c.51-.29,1-.62,1.53-.89l1.62-.75c.27-.13.54-.27.82-.38l.86-.29c.58-.2,1.15-.42,1.74-.59a28.08,28.08,0,0,1,3.67-.75l1-.12c.16,0,.31,0,.47-.06l.48,0,1.93-.07c.65,0,1.3.08,1.95.11.33,0,.66,0,1,.08l1,.16a30.24,30.24,0,0,1,3.91.9l1.91.7.49.18.46.22.93.45.93.46.89.54.9.54.45.27.42.32L176,132.8l1.57,1.45a28.88,28.88,0,0,1,5.18,7,29.24,29.24,0,0,1,2.71,8.28c.1.71.19,1.42.28,2.13s.05,1.43.08,2.14v.53l0,.53-.07,1.05-.07,1-.16,1-.16,1-.09.51-.13.5-.51,2a30.05,30.05,0,0,1-1.5,3.76l-.42.91c-.14.3-.34.57-.5.86-.34.57-.66,1.15-1,1.69s-.77,1.05-1.15,1.57l-.28.39-.32.36-.64.72a29,29,0,0,1-2.69,2.63c-.48.4-1,.75-1.47,1.12l-.73.54c-.25.18-.52.32-.77.48l-1.54.92c-.52.29-1.06.51-1.59.77a25.13,25.13,0,0,1-3.2,1.24l-.4.14-.4.1-.82.2c-.53.12-1.06.27-1.6.36L162,181l-.79.11-.78,0-1.56,0a4.82,4.82,0,0,1-.76,0l-.75,0c-.5,0-1-.05-1.49-.1l-1.43-.23a26.65,26.65,0,0,1-9.62-3.65c-.33-.2-.65-.38-1-.58l-.87-.66-.84-.62c-.14-.11-.28-.2-.4-.31l-.37-.34L140,173.35c-.43-.41-.79-.86-1.16-1.25l-.52-.59a4.05,4.05,0,0,1-.47-.57l-.8-1.09c-.24-.34-.48-.64-.67-.93l-.49-.83-.67-1.11-.23-.38s.07.14.21.39l.65,1.13.47.83c.19.3.43.61.67,1l.79,1.09a4.12,4.12,0,0,0,.47.58l.52.59c.37.4.72.85,1.15,1.27l1.39,1.29.37.33c.13.12.27.21.4.32s.55.42.84.63l.87.66,1,.6a26.68,26.68,0,0,0,9.67,3.69l1.44.24c.49.05,1,.07,1.5.11l.76,0a6.43,6.43,0,0,0,.76,0l1.57-.06.79,0,.79-.1,1.62-.22c.54-.09,1.07-.24,1.61-.36l.82-.19.41-.11.4-.14a24.15,24.15,0,0,0,3.23-1.25c.53-.25,1.08-.48,1.6-.77l1.55-.92c.26-.16.53-.3.78-.48l.74-.55c.49-.37,1-.72,1.48-1.12a30.86,30.86,0,0,0,2.72-2.65l.64-.72.33-.37.28-.39,1.17-1.59c.36-.54.68-1.13,1-1.7.16-.29.36-.56.5-.87l.43-.91a30.06,30.06,0,0,0,1.51-3.8c.18-.67.35-1.34.52-2l.13-.51.09-.52.16-1,.17-1,.07-1.06.07-1.07,0-.53,0-.54c0-.71,0-1.43-.07-2.15s-.18-1.43-.28-2.15a27.38,27.38,0,0,0-8-15.39c-.54-.48-1.07-1-1.59-1.45l-1.71-1.29L174,131l-.45-.28-.9-.55-.9-.54-.94-.46-.94-.45-.47-.23-.49-.18-1.92-.71a31.2,31.2,0,0,0-4-.9l-1-.16c-.33,0-.66,0-1-.08-.66,0-1.31-.1-2-.1l-1.94.06-.49,0-.48.06-1,.13a28.55,28.55,0,0,0-3.7.76c-.59.17-1.17.4-1.75.59l-.87.31c-.28.1-.55.25-.83.37l-1.63.77c-.53.27-1,.6-1.54.89a26.25,26.25,0,0,0-2.85,2l-.34.26-.31.28-.63.57c-.4.39-.83.74-1.21,1.14l-1.09,1.22-.54.6c-.17.21-.32.43-.48.65l-.93,1.27a5.54,5.54,0,0,0-.42.65l-.39.66c-.26.44-.53.87-.76,1.3l-.63,1.34a27.65,27.65,0,0,0-2.5,10.16,26.4,26.4,0,0,0,.74,7.88c.06.27.12.52.18.78a4.91,4.91,0,0,0,.2.71c.16.46.31.89.44,1.28s.26.77.39,1.1l.4.87.56,1.18C134.89,166.47,135,166.6,135,166.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.27,148.09l3.59.16a3.05,3.05,0,0,1,3.26-2.93,2.88,2.88,0,0,1,2.72,2,3.22,3.22,0,0,1-.38,2.9c-.65,1-2,1.82-4.42,1.29l-.35,8.09,3.55.15.2-4.73a6.93,6.93,0,0,0,5.27-6.55c.22-5.24-4.42-6.66-6.43-6.75C158.74,141.62,153.48,141.77,153.27,148.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.53,
    y: 161.31,
    width: 3.6,
    height: 3.36,
    transform: "translate(7.23 -6.77) rotate(2.49)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.08,190l4.1-28.59c1.86-22.29,1.44-49.39,4.76-56.46,6.13-13.06,24.66-13.37,24.66-13.37,24.61-.52,28,18.54,29.64,35.83.27,2.93,1.25,8.17,2.52,14.23,3,12.63,6.91,25.65,15.55,34.57A22.34,22.34,0,0,1,533.25,189c.55,4.71-2.21,10.21-6.92,10.75a10.86,10.86,0,0,1-2.58,17c-4,2.27-9,1.73-13.62,1s-9.31-1.78-12.78-4.83-5.08-7.67-6.26-12.15a105.11,105.11,0,0,1-3-16.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,98.33,477.6,97l16.24,7.52a4.63,4.63,0,0,1,4.14,4.7l-5.22,55.36c-.17,3.67,1.28,5.44-1.08,8.25l-16.2,18.7c-5.66,6.74-4.39-8.67-8.2-16.6-.27-.56,1.11-2.51,1-2.89a10.8,10.8,0,0,1-.19-1.22c-.27-4.37-.11-8.14-.11-8.14,0-4.79,0-6.75-.06-6.71s-10.09-1.68-12.17-14.85c-1-6.55-.33-15.45.49-24.21C457.43,104.74,466.23,97.83,476,98.33Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.55,126.32a1.68,1.68,0,0,0,1.63,1.7,1.62,1.62,0,0,0,1.74-1.52,1.7,1.7,0,0,0-1.63-1.71A1.62,1.62,0,0,0,475.55,126.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.81,125.44a1.69,1.69,0,0,0,1.63,1.7,1.61,1.61,0,0,0,1.74-1.52,1.67,1.67,0,0,0-1.62-1.7A1.62,1.62,0,0,0,458.81,125.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.84,120.42c.21.22,1.49-.73,3.31-.72s3.15.91,3.35.69-.12-.5-.7-.92a4.68,4.68,0,0,0-2.68-.83,4.53,4.53,0,0,0-2.63.85C457.93,119.92,457.74,120.32,457.84,120.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.23,121.54c.23.19,1.41-.88,3.22-1.06s3.23.59,3.4.35-.17-.49-.79-.85a4.63,4.63,0,0,0-2.75-.55,4.52,4.52,0,0,0-2.53,1.12C476.27,121,476.12,121.45,476.23,121.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.23,134.41a12.65,12.65,0,0,0-3-.53c-.47,0-.9-.14-1-.46a2.31,2.31,0,0,1,.31-1.37c.43-1.13.89-2.3,1.37-3.54,1.91-5,3.29-9.17,3.09-9.24s-1.92,3.94-3.82,9l-1.32,3.56a2.64,2.64,0,0,0-.24,1.82,1.14,1.14,0,0,0,.76.68,3.55,3.55,0,0,0,.79.11A11.26,11.26,0,0,0,469.23,134.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,155.92a33.48,33.48,0,0,0,17.64-4.69s-4.44,9.11-17.62,7.87Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.51,137.83c.66-.87,2.6-2.21,3.74-2.09A2.72,2.72,0,0,1,477,137c.48.64,0,2.41-.46,3a2.24,2.24,0,0,1-2.31.95c-.87-.24-2-1.53-2.7-2.1a1.87,1.87,0,0,1-.52-.53c-.12-.22.31-.37.46-.55",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.85,114.38c.23.47,2,.06,4.16.1s3.92.44,4.16,0c.11-.22-.24-.66-1-1.06a7.2,7.2,0,0,0-6.34,0C475.11,113.73,474.75,114.16,474.85,114.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.5,112.64c.32.41,1.57,0,3.08,0s2.78.28,3.07-.16c.13-.21-.07-.62-.63-1a4.45,4.45,0,0,0-5,.15C458.53,112,458.36,112.44,458.5,112.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,132.2s-9.43,2.42-13.53-20.76c-1.4-7.93-8.34-14.64-8.34-14.64l3-.74s18,6.09,18.35,6.33,4.14,9.71,4.14,9.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.24,131.24c0-1,1.13-3.3,2.1-3.45,2.59-.4,7.25-.19,7.29,6.38.06,9-9,7.18-9,6.92S494.23,134.62,494.24,131.24Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.36,137.68s.16.1.43.22a1.53,1.53,0,0,0,1.17,0c.94-.35,1.73-1.86,1.77-3.48a5.19,5.19,0,0,0-.46-2.24,1.76,1.76,0,0,0-1.18-1.19.79.79,0,0,0-.92.43c-.12.25-.06.43-.11.45s-.19-.15-.12-.52a1,1,0,0,1,.35-.57,1.13,1.13,0,0,1,.86-.23,2.18,2.18,0,0,1,1.64,1.38,5.32,5.32,0,0,1,.56,2.5c0,1.81-1,3.51-2.26,3.89a1.66,1.66,0,0,1-1.43-.23C497.38,137.89,497.33,137.69,497.36,137.68Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.4,127.5a11.25,11.25,0,0,1-1.32-.34,7.94,7.94,0,0,1-3.1-2,10.75,10.75,0,0,1-1.56-2,14.8,14.8,0,0,1-1.22-2.69,55.1,55.1,0,0,1-1.6-6.6,67.88,67.88,0,0,0-1.73-6.61,38.62,38.62,0,0,0-2.08-5.18,28,28,0,0,0-1.89-3.25c-.25-.37-.47-.64-.6-.83a1.9,1.9,0,0,0-.23-.27,1.91,1.91,0,0,0,.19.3c.12.2.33.48.56.85a31.47,31.47,0,0,1,1.82,3.28,39.71,39.71,0,0,1,2,5.17c.63,2,1.19,4.22,1.7,6.59a53.6,53.6,0,0,0,1.63,6.63,14.41,14.41,0,0,0,1.26,2.71,10.75,10.75,0,0,0,1.61,2,7.86,7.86,0,0,0,3.19,2A4.81,4.81,0,0,0,490.4,127.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.89,168.58s-13.81,12.54-10.61,28.55,3,49.48,3,49.48-1.37,13-3.23,27.15c-1.78,13.51-5.63,35.75-5.63,35.75l14.84,6.37s13-42.41,14.77-55.76c2.26-17.23-2.34-57.15-2.34-57.15Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4,307.35l-30.64,5.94s-1.45,1.93,1.45,2.17,43.65,0,43.65,0Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,246.29c0,.15-2.95-.32-6.57-.55s-6.57-.16-6.58-.3a7,7,0,0,1,1.93-.23,43.92,43.92,0,0,1,4.68,0,43.35,43.35,0,0,1,4.65.56A7.3,7.3,0,0,1,456.94,246.29Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.91,318.66s37.17,2.67,55.27,1.51c11-.7,19.62-12.82,9.59-21.46-4.85-4.17-65.71-17.67-65.71-17.67C545.47,289.2,552.24,309.35,557.91,318.66Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.77,300.11c0,.12-8.09-2.48-18-5.83S588.92,288.12,589,288s8.09,2.48,18,5.83S624.81,300,624.77,300.11Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.44,247.12s33.87,16,48.62,26.54c8.94,6.4,9.88,21.26-3.21,23.28-6.32,1-65.11-19.76-65.11-19.76C554.22,264.12,569.7,252,579.44,247.12Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.08,234.2l3.3,3.06s11.86-6,30.83,2.15c11.54,5,40.18,19.27,40.18,19.27s-16.27,5.49-16,19.36S589.12,292,584.55,295s-21.41,1.4-23.12,12.39-2.29,11.95-2.29,11.95-48.46-1.56-62.73-7.84-19.48-41.53-19.48-41.53l-1.75-7.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.09,286.25a3.31,3.31,0,0,1-.72-.17l-2-.58-7.48-2.21-24.64-7.44A72.17,72.17,0,0,0,532.38,273a36.22,36.22,0,0,0-11.44.75,25.28,25.28,0,0,0-7.18,2.87c-.78.47-1.37.87-1.76,1.16a4.41,4.41,0,0,1-.61.42,4.77,4.77,0,0,1,.55-.49,17.82,17.82,0,0,1,1.72-1.26,24.51,24.51,0,0,1,7.2-3,35.8,35.8,0,0,1,11.56-.87,71.68,71.68,0,0,1,13.91,2.79c9.64,2.89,18.32,5.62,24.61,7.58l7.44,2.36,2,.67A3.75,3.75,0,0,1,581.09,286.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.13,260.12a30.07,30.07,0,0,0-3,6,28.05,28.05,0,0,0-1,6.59,5.94,5.94,0,0,1-.2-2,15.75,15.75,0,0,1,.77-4.76,16.25,16.25,0,0,1,2.15-4.31A5.85,5.85,0,0,1,542.13,260.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465,240.76l10.77,22.11s41.65-11.34,48.24-19.15,8.79-11.1,8.79-11.1l-15.93-29.2-3.43-37.59L495.3,163.1c-9.65,4.91-23,6-26.78.47,0,0-10.81.07-18.62,4.43L442,189.12Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.9,219.44h21.31l-7.54-52.2s-11.77,4-13.77,16.24C436.19,194,437.9,219.44,437.9,219.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.18,186.65a3.23,3.23,0,0,1,.08.53c0,.41.09.92.14,1.55s.13,1.5.24,2.45.21,2,.39,3.22c.31,2.39.79,5.22,1.44,8.34s1.55,6.5,2.65,10,2.37,6.78,3.61,9.71,2.5,5.51,3.63,7.64c.54,1.08,1.09,2,1.54,2.86s.87,1.55,1.22,2.13l.77,1.35a2,2,0,0,1,.24.49,2.59,2.59,0,0,1-.32-.44l-.85-1.3c-.37-.56-.81-1.26-1.29-2.1s-1.06-1.76-1.61-2.83c-1.17-2.11-2.45-4.7-3.74-7.62s-2.54-6.22-3.66-9.74-2-6.93-2.63-10.06-1.08-6-1.34-8.38c-.16-1.2-.23-2.29-.32-3.25s-.13-1.78-.16-2.46,0-1.14,0-1.55A1.7,1.7,0,0,1,448.18,186.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.75,165.81a20.19,20.19,0,0,1,18.27,13c5,12.77,5.93,29.36,5.93,29.36l-26.88,5.71L513,191s-3.17-9.35-3.48-14.72C508.81,163.3,512.75,165.81,512.75,165.81Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537,208.19a1.71,1.71,0,0,1-.48.15l-1.41.31-5.2,1.07-17.36,3.39-.25,0,0-.27c-.06-.43-.11-.9-.17-1.37L509.89,193c-.25-2.32-.45-4.22-.6-5.61-.06-.62-.1-1.13-.14-1.53a2.76,2.76,0,0,1,0-.54,2,2,0,0,1,.12.53c.06.4.13.9.22,1.51.19,1.39.45,3.28.76,5.6.6,4.78,1.41,11.29,2.3,18.47.06.47.12.94.17,1.38l-.29-.22,17.39-3.24,5.23-.92,1.42-.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.64,208.47,515.72,212l1.07,6.15-7.67-.68-15.62,7.33s13.05,14.13,21.17,18,21.24,5.64,22.94-8.57C538.76,224.59,535.64,208.47,535.64,208.47Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.19,227.93c-.06,0-.7-.82-1.89-2.07a25.18,25.18,0,0,0-5.23-4.16,24.87,24.87,0,0,0-6.16-2.6c-1.66-.45-2.73-.59-2.72-.67s.27,0,.76,0a15.11,15.11,0,0,1,2,.32,21.68,21.68,0,0,1,6.33,2.52,21.91,21.91,0,0,1,5.24,4.35,15,15,0,0,1,1.26,1.64C532.09,227.68,532.22,227.91,532.19,227.93Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.85,208.33s2.18-2.87,3.82-3.51A22.55,22.55,0,0,1,504,204s-.82-3,2.27-3.27a4.32,4.32,0,0,0,2.18,1,1.72,1.72,0,0,1,2,1.45c.28,1.18,1,4.45,0,6s-2.81,3.09-2,7.26c0,0-1.09,4.63-3.45,5.81a7.77,7.77,0,0,1-3.54,1.09s-2.18,2.64-4,2.27-2.63-.45-2.63-.45-1.45,2.25-4.63.49a3.56,3.56,0,0,1-3.54.24c-.85-.46-5-4.63-5.18-7.81s-.05-5.36.73-6.54c1.17-1.74,2.86-.16,2.86-.16s.41-3,1.59-4.2,2.09-1,2.09-1-.37-3.64,2.45-3.91,2.54,3.09,2.63,4.9L494,209S495.08,206.33,497.85,208.33Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.85,208.33c0,.06-.36-.24-1.08-.5a2.16,2.16,0,0,0-1.37-.05,2.41,2.41,0,0,0-1.32,1.28l-.24.51,0-.56c-.05-.78-.12-1.64-.15-2.61a7.43,7.43,0,0,0-.52-3c-.41-1-1.82-1.17-2.83-.62s-1.37,2-1.28,3.35l0,.29h-.33a3,3,0,0,0-2.35,1.64,10.74,10.74,0,0,0-1,3.34l-.09.53-.4-.36a1.62,1.62,0,0,0-2-.34,3.46,3.46,0,0,0-1,2.2,16.3,16.3,0,0,0-.15,2.73A12.86,12.86,0,0,0,482,219a13.58,13.58,0,0,0,3.05,4.94c.34.38.7.74,1.07,1.08a6.2,6.2,0,0,0,.56.48,2.31,2.31,0,0,0,.61.3,3.2,3.2,0,0,0,2.73-.41l.19-.12.17.1a4,4,0,0,0,2.84.53,2.55,2.55,0,0,0,1.34-.91l.14-.18.19,0,1.88.33c.3,0,.66.12.91.14a1.92,1.92,0,0,0,.78-.09,7,7,0,0,0,2.76-2.07l.1-.12h.18a7.37,7.37,0,0,0,2.51-.66,4.4,4.4,0,0,0,2.06-1.42,12.76,12.76,0,0,0,2.09-4.56v.13a7.68,7.68,0,0,1,.69-5.47c.44-.79,1-1.46,1.44-2.13a4.59,4.59,0,0,0,.4-2.25,14.46,14.46,0,0,0-.25-2.29,4.24,4.24,0,0,0-.63-2,1.35,1.35,0,0,0-.8-.39c-.3-.07-.67,0-1-.11a5.18,5.18,0,0,1-1.82-1l.17.05a2.31,2.31,0,0,0-1.91,1,2.92,2.92,0,0,0-.21,2l0,.17-.17.05-1.65.55a5,5,0,0,0-1.38.59,12.28,12.28,0,0,0-1.82,1.55c-.46.47-.79.84-1,1.09s-.34.39-.35.37a1.77,1.77,0,0,1,.28-.43c.2-.27.51-.66.95-1.16a11.73,11.73,0,0,1,1.81-1.65,5.22,5.22,0,0,1,1.43-.66l1.66-.6-.12.22a3.2,3.2,0,0,1,.19-2.26,2.74,2.74,0,0,1,2.23-1.27h.09l.07.06a4.57,4.57,0,0,0,1.64.88c.51.11,1.49-.06,2.1.61a2.31,2.31,0,0,1,.55,1.09c.08.37.17.74.24,1.12a16.33,16.33,0,0,1,.29,2.37,5.13,5.13,0,0,1-.46,2.54c-.46.78-1,1.4-1.42,2.14a7,7,0,0,0-.59,5.06v.07l0,.07a13.21,13.21,0,0,1-2.19,4.83,4.92,4.92,0,0,1-1,1,8.89,8.89,0,0,1-1.27.64,7.6,7.6,0,0,1-2.81.71l.29-.12a7.71,7.71,0,0,1-3.07,2.29,2.69,2.69,0,0,1-1.06.12c-.38,0-.63-.1-.95-.15l-1.85-.32.33-.15a3.21,3.21,0,0,1-1.74,1.19,4.59,4.59,0,0,1-3.35-.59l.37,0a3.89,3.89,0,0,1-3.34.49,2.82,2.82,0,0,1-.8-.39c-.22-.17-.43-.35-.62-.53-.39-.36-.76-.74-1.11-1.13a14.09,14.09,0,0,1-3.19-5.23,13.1,13.1,0,0,1-.24-2.95,16.74,16.74,0,0,1,.16-2.84,4,4,0,0,1,1.26-2.58,1.77,1.77,0,0,1,1.5-.29,3.17,3.17,0,0,1,1.25.68l-.49.18a11.12,11.12,0,0,1,1.09-3.52,3.85,3.85,0,0,1,1.21-1.35,2.6,2.6,0,0,1,1.72-.54l-.31.28a5.56,5.56,0,0,1,.26-2.16,2.86,2.86,0,0,1,1.3-1.65,3,3,0,0,1,2-.3,2,2,0,0,1,1.47,1.15,7.55,7.55,0,0,1,.5,3.14c0,1,.06,1.83.08,2.6l-.27-.05a2.64,2.64,0,0,1,1.52-1.37,2.28,2.28,0,0,1,1.48.12A3.44,3.44,0,0,1,497.85,208.33Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.41,207.56c0,.08-.33.15-.83,0a3.29,3.29,0,0,1-1.72-1.06,3.41,3.41,0,0,1-.81-1.84c0-.52.07-.83.15-.83s.28,1.2,1.18,2.22S507.45,207.37,507.41,207.56Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.33,216.75c-.19.07-1-2.06-2.51-4.4s-3.12-3.92-3-4.07,2,1.26,3.56,3.7S503.5,216.7,503.33,216.75Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,208.28c.11,0-.06.87.23,2.19a17.5,17.5,0,0,0,2.18,4.84,18.76,18.76,0,0,1,1.31,2.73,22.09,22.09,0,0,1,.61,2.38,3.14,3.14,0,0,0,1.16,1.73s-.25,0-.6-.18a2.76,2.76,0,0,1-1-1.4c-.26-.69-.39-1.48-.74-2.3a22.28,22.28,0,0,0-1.32-2.63,14.27,14.27,0,0,1-2.06-5.09A3.42,3.42,0,0,1,494,208.28Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.53,220.68a6.11,6.11,0,0,1-1.83-1.5,7.33,7.33,0,0,1-1.47-2.17,10.36,10.36,0,0,1-.63-3.12c-.42-4.43.08-8,.26-8s0,3.57.42,7.93a11.07,11.07,0,0,0,.54,2.95,7.8,7.8,0,0,0,1.25,2.08C492,220,492.61,220.6,492.53,220.68Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.48,221.52c-.1,0-.39-.52-1.11-1.29a12.46,12.46,0,0,1-1.21-1.45,4.75,4.75,0,0,1-.79-2.28,17.75,17.75,0,0,1,.43-4.18,8.73,8.73,0,0,1,.27-1.69,3.13,3.13,0,0,1,.22,1.74,31.34,31.34,0,0,0-.23,4.07,6.38,6.38,0,0,0,1.69,3.49C487.4,220.8,487.57,221.5,487.48,221.52Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.4,141.16a4.53,4.53,0,0,0,1.61-.8,2.75,2.75,0,0,0,.9-1.6,2.64,2.64,0,0,0-.66-2.09,2.47,2.47,0,0,0-1.15-.77h.17a37.42,37.42,0,0,0-4.19,2.33,10,10,0,0,1,4-2.8l.09,0,.09,0a3.07,3.07,0,0,1,1.39.91,2.9,2.9,0,0,1-.4,4.33A2.12,2.12,0,0,1,474.4,141.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.31,226.7c-.22-6.82.55-13.66,0-20.46s-2.68-13.82-7.65-18.49-13.31-6.17-18.7-2l-.88,5.85c3.37,26.19,4.27,52.92,7.64,79.11.44,3.44,3.39,6.44,5.1,9.46s5,5.43,8.42,5.06c4.51-.48,7.28-5.2,8.49-9.58C716.11,259.82,709.85,243.15,709.31,226.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.67,190.93a17,17,0,0,0-3-4.34,5.87,5.87,0,0,0-4.83-1.74,2.44,2.44,0,0,0-2,1.36c-.29.79.27,1.85,1.11,1.8l.17.16q2.73,2.52,5.55,4.94a4.71,4.71,0,0,0,1.56,1,1.69,1.69,0,0,0,1.74-.32C695.65,193,695.17,191.83,694.67,190.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698,197.09c-6-7.69-14.18-12.22-23.92-12.61-5.5-.22-7.8.87-11.78,1.85a17.3,17.3,0,0,0-10.05,6.31c-2.89,3.92-5.35,8.32-6,13.15a81.57,81.57,0,0,0-1.06,15,27.35,27.35,0,0,0,4.34,14.17l12.64,2.5c7,.41,14.11.8,21-.64s13.59-5,17.38-10.86C705.84,217.71,704,204.78,698,197.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.74,196.74,670,189.62l-4.43.41c-9.95-.19-17.07,10.62-17.32,18.67-.28,9-.27,19.89,1,26.52,2.55,13.33,13.85,14.7,13.85,14.7s-.4,7.06-.59,11.52l9.44,15.49,16.52-16.76,2.67-58.78A4.72,4.72,0,0,0,686.74,196.74Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.54,219.45a1.72,1.72,0,0,0,1.71,1.69,1.64,1.64,0,0,0,1.72-1.61,1.71,1.71,0,0,0-1.71-1.68A1.64,1.64,0,0,0,651.54,219.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.15,213.25c.22.22,1.49-.79,3.34-.84s3.24.83,3.43.59-.14-.5-.74-.91a4.73,4.73,0,0,0-2.75-.75,4.52,4.52,0,0,0-2.65.95C651.22,212.74,651,213.15,651.15,213.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.68,228a11.86,11.86,0,0,0-3-.45c-.47,0-.92-.11-1-.43a2.43,2.43,0,0,1,.27-1.41l1.28-3.64c1.78-5.18,3-9.43,2.84-9.5s-1.82,4.07-3.6,9.25c-.42,1.28-.83,2.49-1.22,3.66a2.76,2.76,0,0,0-.19,1.86,1.23,1.23,0,0,0,.8.67,3,3,0,0,0,.81.08A11.85,11.85,0,0,0,662.68,228Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.05,249.9a34.07,34.07,0,0,0,17.79-5.35s-4.49,9.44-17.94,8.61Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.93,206.8c.32.44,1.73.09,3.39.18s3,.47,3.39.06c.16-.21,0-.64-.62-1.08a5.28,5.28,0,0,0-5.47-.19C652,206.16,651.79,206.58,651.93,206.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.87,219.13a1.72,1.72,0,0,1-1.67,1.73,1.65,1.65,0,0,1-1.76-1.56,1.72,1.72,0,0,1,1.67-1.73A1.65,1.65,0,0,1,671.87,219.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.16,213.12c-.21.22-1.51-.75-3.36-.76s-3.21.91-3.41.68.12-.5.71-.93a4.79,4.79,0,0,1,2.74-.82,4.47,4.47,0,0,1,2.67.88C676.08,212.61,676.27,213,676.16,213.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.19,207.17c-.37.42-1.79,0-3.51,0s-3.17.26-3.5-.18c-.15-.22.08-.64.72-1a5.32,5.32,0,0,1,2.86-.67,5.15,5.15,0,0,1,2.79.86C675.15,206.53,675.35,207,675.19,207.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.28,223.83c0-1,1.05-3.39,2-3.58,2.62-.49,7.37-.43,7.63,6.25.35,9.14-8.9,7.6-8.92,7.34S688.38,227.27,688.28,223.83Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.41,230.41s.16.11.44.22a1.62,1.62,0,0,0,1.19,0c1-.39,1.7-2,1.69-3.6a5.31,5.31,0,0,0-.54-2.27,1.84,1.84,0,0,0-1.24-1.17.8.8,0,0,0-.92.47c-.12.26,0,.44-.1.46s-.2-.15-.14-.53a1,1,0,0,1,.34-.58,1.2,1.2,0,0,1,.87-.27,2.24,2.24,0,0,1,1.71,1.35,5.42,5.42,0,0,1,.65,2.53c0,1.84-.86,3.6-2.17,4a1.68,1.68,0,0,1-1.46-.19C691.44,230.63,691.38,230.43,691.41,230.41Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.69,220.29l-2.38,2.35c-9.78-9.81-28.78-34.25-27.72-32.8a29.14,29.14,0,0,1,14.33-1.22c7.41,1.44,21.44,5.5,21,14.27S690.69,220.29,690.69,220.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704,218.58a3.17,3.17,0,0,0-.13-.53,9.56,9.56,0,0,0-.59-1.45,13.29,13.29,0,0,0-3.71-4.38,25.07,25.07,0,0,0-7.59-3.87c-3-1.06-6.45-1.92-9.79-3.44a45,45,0,0,1-8.9-5.26,46.41,46.41,0,0,1-6.23-5.71,47.65,47.65,0,0,1-3.57-4.45c-.37-.52-.66-.94-.89-1.28a3.08,3.08,0,0,0-.33-.43,1.91,1.91,0,0,0,.25.48c.18.31.44.77.82,1.33a40.56,40.56,0,0,0,3.48,4.57A43.79,43.79,0,0,0,682,205.33a100.53,100.53,0,0,0,9.84,3.43,25.43,25.43,0,0,1,7.53,3.72,13.76,13.76,0,0,1,3.75,4.2C703.75,217.87,703.94,218.6,704,218.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.3,220a4.76,4.76,0,0,0-.31-2,9.34,9.34,0,0,0-3.33-4.38,20.57,20.57,0,0,0-7.54-3.16,44.9,44.9,0,0,1-9.39-3.22,40.52,40.52,0,0,1-8.31-5.4,41.51,41.51,0,0,1-5.65-5.82,44.59,44.59,0,0,1-3.12-4.5l-.74-1.3a2.78,2.78,0,0,0-.29-.44,2.35,2.35,0,0,0,.21.48c.17.36.39.8.66,1.35a38.53,38.53,0,0,0,3,4.61,40,40,0,0,0,5.63,5.95,39.4,39.4,0,0,0,8.39,5.49,44.64,44.64,0,0,0,9.48,3.22,20.82,20.82,0,0,1,7.46,3,9.42,9.42,0,0,1,3.35,4.17A10.56,10.56,0,0,1,701.3,220Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690,235.72c0-.06.77-.14,2.13-.46a13,13,0,0,0,5.17-2.74,18.31,18.31,0,0,0,4.91-7.14,32,32,0,0,0,2.22-10.48,26.61,26.61,0,0,0-.31-5.54,26.93,26.93,0,0,0-1.39-5,26.52,26.52,0,0,0-4.56-7.47,43.18,43.18,0,0,0-6-5.48,2.32,2.32,0,0,1,.5.28c.31.2.79.48,1.36.9a28.64,28.64,0,0,1,4.46,4,26.11,26.11,0,0,1,4.75,7.54,25.06,25.06,0,0,1,1.8,10.76,31.73,31.73,0,0,1-2.32,10.66,18.45,18.45,0,0,1-5.14,7.26,12.76,12.76,0,0,1-5.39,2.64,13.32,13.32,0,0,1-1.63.22C690.22,235.74,690,235.75,690,235.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.32,229.49a1.45,1.45,0,0,1,.8-.27,1.17,1.17,0,0,1,.68.36,3.13,3.13,0,0,1-2.15,5.41c-1.24,0-2.72-.71-3.47-3C665.48,231.27,667,230.25,668.32,229.49Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.65,235a4.76,4.76,0,0,0,1.8-.79,3,3,0,0,0,1.06-1.75,3.09,3.09,0,0,0-.58-2.39c-.27-.34-.62-.67-.94-.62a4,4,0,0,0-1.08.54L666,231.1a8.59,8.59,0,0,1-1.82.93,9.22,9.22,0,0,1,1.66-1.2l1.86-1.21a4,4,0,0,1,1.24-.62,1.1,1.1,0,0,1,.8.24,2.86,2.86,0,0,1,.55.55,3.41,3.41,0,0,1,.62,2.74,3.13,3.13,0,0,1-1.27,1.92A2.45,2.45,0,0,1,667.65,235Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.8,393l-30.14-10.56c-5.32-1.18-10.9-2.35-16.15-.89s-9.93,6.51-9,11.88c.74,4.31,4.85,7.41,9.13,8.31s8.72,0,13-.93,8.61-2.06,13-1.59c2.9.31,5.68,1.3,8.54,1.86s6,.65,8.53-.75S628.93,395.72,627.8,393Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.89,312.61c-5.77,4.23-10.92,8-10.84,23.9s1.78,23.19,1.78,23.19l64.31,6.2,6.5-18.47S605.83,302.39,591.89,312.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.38,357.12a7,7,0,0,1-.6-1.25c-.35-.81-.87-2-1.54-3.43a107.07,107.07,0,0,0-12.81-21.18c-1-1.25-1.77-2.26-2.33-2.95a7.16,7.16,0,0,1-.82-1.11,6.9,6.9,0,0,1,1,1c.61.65,1.45,1.62,2.46,2.85a90.75,90.75,0,0,1,7.17,10.18,88.86,88.86,0,0,1,5.69,11.08c.62,1.46,1.09,2.67,1.39,3.51A7.1,7.1,0,0,1,615.38,357.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.69,344.32l-8.28,10.08-3.77,1.83S602,343.24,591,341s-33.13-5.73-36.07,12.13,15.28,24.28,22.79,28.39,31.18,9.95,31.18,9.95,32.63,9.23,43.88,9.67c11.8.46,34.69-1.69,40.56-7.77s12-26.08,12-26.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.61,393.32a2.34,2.34,0,0,1-.56-.1l-1.58-.38c-1.38-.33-3.36-.87-5.79-1.59a187.38,187.38,0,0,1-36.48-15.19c-2.22-1.21-4-2.24-5.2-3l-1.39-.85a3.77,3.77,0,0,1-.47-.33,2.19,2.19,0,0,1,.52.24l1.44.77c1.24.68,3,1.66,5.27,2.83,4.48,2.35,10.75,5.43,17.87,8.4s13.73,5.24,18.55,6.76c2.41.76,4.37,1.35,5.73,1.75l1.56.47A2.43,2.43,0,0,1,615.61,393.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.43,357.1a3,3,0,0,1-.65-.2l-1.82-.68c-1.58-.6-3.88-1.46-6.72-2.48-5.69-2.05-13.61-4.69-22.51-7.13s-17.07-4.19-23-5.31c-3-.57-5.37-1-7-1.28l-1.92-.35a3,3,0,0,1-.66-.15,3.15,3.15,0,0,1,.68.05l1.93.25c1.68.22,4.1.6,7.08,1.12,6,1,14.16,2.74,23.08,5.17s16.84,5.14,22.5,7.28c2.83,1.07,5.11,2,6.66,2.64l1.79.77A3.54,3.54,0,0,1,644.43,357.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.06,351.26l8.18-18.92-4.39-26.81,12.54-44,25.91-9.15S703,258,708.22,278.73c5.77,22.78,4,51.83,2.78,63.42s-7.29,32.56-7.29,32.56-14.57,6.09-40.21-7.08c-19.37-10-20.26-11.93-20.26-11.93S643.57,352.11,646.06,351.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.86,307.29s-28-27.45-32.55-30.05l-7.09,3.62v8.56l25.31,33.75A26.25,26.25,0,0,0,655.86,307.29Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699,284.8s-24.64,47.4-38.22,47.39a28,28,0,0,1-25.41-15.06l11.26-18.82,5.52,3.68s18.21-36,22.1-41.13,16.08-7.34,21.69-2.25C701.34,263.51,705.28,275.06,699,284.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699,284.8l.23-.44.71-1.28c.28-.58.6-1.32.95-2.19l.46-1.45c.17-.52.25-1.09.39-1.69a20.75,20.75,0,0,0-.26-8.87,21.39,21.39,0,0,0-2-5.24,17.92,17.92,0,0,0-3.77-5,12,12,0,0,0-6.27-2.6,19.61,19.61,0,0,0-7.46.51,15,15,0,0,0-7,3.72c-.22.26-.47.51-.67.79l-.6.87c-.4.58-.75,1.21-1.13,1.82-.73,1.24-1.46,2.51-2.18,3.81-5.76,10.39-11.76,22.09-18.07,34.5l-.12.24-.22-.15-5.52-3.68.32-.07-2.48,4.16c-3,5-6,10-8.77,14.66V317a27.89,27.89,0,0,0,13.7,12.69,29.67,29.67,0,0,0,8.7,2.11,16.67,16.67,0,0,0,4.3,0l1-.29c.33-.12.64-.29,1-.42a16.15,16.15,0,0,0,1.83-1,35.62,35.62,0,0,0,6.16-5.31c1.82-1.91,3.47-3.88,5-5.81,3.06-3.88,5.69-7.65,8-11.13,4.6-7,8-12.78,10.26-16.79l2.59-4.62.67-1.2.23-.41s-.06.15-.19.43l-.63,1.22c-.56,1.07-1.41,2.64-2.53,4.66-2.24,4-5.57,9.87-10.15,16.87-2.28,3.5-4.91,7.29-8,11.2-1.55,1.94-3.19,3.91-5,5.85a36.59,36.59,0,0,1-6.22,5.38,17.87,17.87,0,0,1-1.87,1c-.34.14-.66.31-1,.43l-1.06.31a16.77,16.77,0,0,1-4.42.07,29.65,29.65,0,0,1-8.84-2.13,28.24,28.24,0,0,1-14-12.91l0-.1.07-.11L644,302.35l2.49-4.16.12-.21.2.13,5.53,3.69-.34.09c6.33-12.42,12.34-24.11,18.13-34.5.72-1.3,1.46-2.57,2.2-3.82.39-.61.73-1.24,1.14-1.83l.61-.89c.21-.29.47-.55.71-.82a15.22,15.22,0,0,1,7.21-3.8,19.88,19.88,0,0,1,7.59-.5,12.28,12.28,0,0,1,6.43,2.71,18.29,18.29,0,0,1,3.82,5.07,22.55,22.55,0,0,1,1.94,5.31,20.85,20.85,0,0,1,.18,9c-.14.6-.23,1.18-.41,1.7l-.48,1.45q-.56,1.32-1,2.19l-.75,1.26C699.11,284.66,699,284.8,699,284.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.39,278s-7.17-5.7-20.91-6.72-21.05-.59-21.05,1,.15,1.5,1.32,2.07,11.25.42,12.13,1.88-.15,1.17-.15,1.17-16.53,2.48-16.66,4.24c-.28,3.64,2.19,2.78,2.19,2.78s13.6-3.07,14.47-2.34,1.61.14.88.73-15.79,5.55-15.49,6.58,1.17,2.63,2.77,2,13.75-5.41,14.48-4.67,1,1.75,0,2.33-10.82,9.15-10.24,9.62,1.17,1.79,2.78.76,11.26-8.47,13.45-9.06,13.74-1,13.74-1",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.1,289.39l-.47,0-1.4.08-5.39.33c-1.16.09-2.46.18-3.88.32-.7.07-1.44.15-2.19.29a6.6,6.6,0,0,0-2.14,1c-2.82,1.74-5.86,4-9.24,6.48-.86.62-1.67,1.28-2.65,1.87a2.22,2.22,0,0,1-.85.26,1.46,1.46,0,0,1-.89-.26,3.8,3.8,0,0,1-.66-.6,3.9,3.9,0,0,0-.28-.29l0,0s-.09-.11-.08-.15a.37.37,0,0,1,0-.2,1.45,1.45,0,0,1,.12-.22,21.78,21.78,0,0,1,2.41-2.58c.86-.83,1.75-1.65,2.67-2.47s1.85-1.66,2.82-2.48c.49-.42,1-.83,1.49-1.24a8.73,8.73,0,0,1,.8-.59,1.06,1.06,0,0,0,.52-.61,1.12,1.12,0,0,0-.12-.81,2.26,2.26,0,0,0-.25-.38l-.15-.17s-.06-.06-.06,0h0a7.06,7.06,0,0,0-1.88.34c-1.29.36-2.58.8-3.89,1.25-2.61.92-5.25,1.94-8,3a3.61,3.61,0,0,1-1.11.32,1.88,1.88,0,0,1-1.17-.35,3.73,3.73,0,0,1-1.25-1.95v0a.38.38,0,0,1,0-.1.34.34,0,0,1,0-.16.83.83,0,0,1,.12-.17,1.5,1.5,0,0,1,.24-.21c.17-.11.33-.21.5-.3.33-.19.67-.35,1-.51q1-.48,2.07-.9c2.8-1.14,5.68-2.18,8.6-3.27l2.18-.83a3.61,3.61,0,0,0,1-.5l.08-.07s0,0,0,0a.19.19,0,0,0,.06.25l.06,0h0l-.31,0a1.74,1.74,0,0,1-.62-.24,1.31,1.31,0,0,1-.27-.19l-.06,0-.11,0a4.87,4.87,0,0,0-.55,0c-.38,0-.77.05-1.16.09-.79.09-1.57.21-2.36.34-3.41.58-6.77,1.29-10.05,2h0a1.77,1.77,0,0,1-2.41-1.43,4.9,4.9,0,0,1-.09-1.47.69.69,0,0,1,.15-.45,1.33,1.33,0,0,1,.31-.28,3.8,3.8,0,0,1,.65-.36,32.88,32.88,0,0,1,5.33-1.55c3.55-.78,7-1.38,10.42-1.91h.09a.38.38,0,0,0,.22,0,.53.53,0,0,0,0-.17,2.49,2.49,0,0,0-.3-.68,2.61,2.61,0,0,0-1.32-.59,22.37,22.37,0,0,0-3.15-.47c-2.12-.21-4.2-.29-6.24-.5a4.15,4.15,0,0,1-1.53-.35,5.18,5.18,0,0,1-.7-.36,1,1,0,0,1-.47-.74,5.27,5.27,0,0,1,0-.78,2,2,0,0,1,0-.41.92.92,0,0,1,.23-.41,3.3,3.3,0,0,1,1.41-.66,28.65,28.65,0,0,1,5.67-.53c3.68-.05,7.13.12,10.33.32a78,78,0,0,1,8.8.91,43.68,43.68,0,0,1,11.89,3.86,25.37,25.37,0,0,1,2.88,1.67c.32.21.55.38.71.5a2.08,2.08,0,0,1,.22.18,1.28,1.28,0,0,1-.25-.15c-.16-.11-.39-.27-.72-.47a29.59,29.59,0,0,0-2.91-1.6A44.17,44.17,0,0,0,608.64,272a77.33,77.33,0,0,0-8.77-.86c-3.19-.18-6.64-.34-10.3-.27a28,28,0,0,0-5.58.54,3,3,0,0,0-1.23.55c-.14.15-.13.26-.13.55a5.24,5.24,0,0,0,0,.7.68.68,0,0,0,.3.49,5.61,5.61,0,0,0,.65.33,3.88,3.88,0,0,0,1.4.31c2,.2,4.11.27,6.24.48a24.52,24.52,0,0,1,3.22.47,5.7,5.7,0,0,1,.8.25,1.59,1.59,0,0,1,.78.54,3.23,3.23,0,0,1,.36.82.59.59,0,0,1-.16.6.71.71,0,0,1-.59.07h.09c-3.38.53-6.86,1.14-10.39,1.92a32.77,32.77,0,0,0-5.24,1.53c-.38.18-.88.42-.85.7a4.89,4.89,0,0,0,.08,1.33,1.51,1.51,0,0,0,.63,1,1.53,1.53,0,0,0,1.19.1h0c3.29-.73,6.64-1.44,10.08-2,.79-.12,1.58-.25,2.37-.34.4,0,.8-.08,1.21-.09a3.37,3.37,0,0,1,.63,0l.18,0a.7.7,0,0,1,.21.11l.21.14a1.42,1.42,0,0,0,.48.19,1.85,1.85,0,0,0,.27,0h.06s0,0,.13.05a.26.26,0,0,1,.07.32l-.05.08-.14.12a3.77,3.77,0,0,1-1.1.58l-2.19.83c-2.92,1.09-5.8,2.13-8.59,3.26-.69.28-1.38.57-2,.88-.34.16-.67.32-1,.5a3.85,3.85,0,0,0-.45.28c-.14.07-.27.27-.22.18a3.23,3.23,0,0,0,1.08,1.7,1.36,1.36,0,0,0,.89.27,3.33,3.33,0,0,0,1-.28c2.7-1,5.35-2.05,8-3,1.31-.45,2.61-.89,3.92-1.25a6.73,6.73,0,0,1,2.06-.35.51.51,0,0,1,.32.18,1.71,1.71,0,0,1,.18.2,2,2,0,0,1,.29.45,1.54,1.54,0,0,1,.16,1.1,1.45,1.45,0,0,1-.72.85,8.57,8.57,0,0,0-.75.56c-.5.4-1,.81-1.48,1.22-1,.82-1.91,1.64-2.83,2.46s-1.8,1.64-2.66,2.45a23.05,23.05,0,0,0-2.37,2.51,1.15,1.15,0,0,0-.08.15s0,0-.09,0h0s-.08.08.07-.09l0,0c.12.11.22.22.31.32a3.28,3.28,0,0,0,.59.54,1.26,1.26,0,0,0,1.39,0c.91-.54,1.77-1.22,2.62-1.82,3.39-2.46,6.44-4.71,9.29-6.44a7.26,7.26,0,0,1,2.23-1c.77-.13,1.51-.21,2.22-.27,1.42-.13,2.72-.21,3.89-.28,2.34-.13,4.16-.2,5.39-.24l1.4,0Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.26,316.41a54.93,54.93,0,0,1-.58-7.15,54.68,54.68,0,0,1-.11-7.16,57.82,57.82,0,0,1,.57,7.14A53.94,53.94,0,0,1,653.26,316.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.41,337.35c0-.13,7.74.79,17.25,2s17.21,2.38,17.19,2.5-7.74-.78-17.25-2S658.4,337.47,658.41,337.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.39,335.42c0-.12,4.37-1.42,9.84-2.89s9.92-2.56,9.95-2.43-4.37,1.41-9.83,2.88S668.43,335.54,668.39,335.42Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.68,95.6l1.19-.07c11.89-.66,22.31,7.66,23.95,19.13,1.52,10.67,3.06,22.46,3.33,28.21.55,11.91-11.59,14.45-11.59,14.45l.44,4.84c.72,8-3.36,19.68-11.59,20.34l-2.84-1.66c-8.13.65-14.47-8.15-15.24-16L263,120.62C261.15,108.32,267,97,279.68,95.6Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,157.3a30.51,30.51,0,0,1-16.31-3.67s4.28,8.35,16.43,6.6Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39,125.72a1.72,1.72,0,0,1-1.59,1.81,1.67,1.67,0,0,1-1.89-1.43,1.71,1.71,0,0,1,1.58-1.81A1.67,1.67,0,0,1,301.39,125.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.53,120.63c-.21.23-1.59-.65-3.47-.54s-3.21,1.1-3.42.89.09-.51.66-1a4.89,4.89,0,0,1,2.73-1,4.68,4.68,0,0,1,2.77.7C302.41,120.13,302.63,120.52,302.53,120.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.12,126.84a1.72,1.72,0,0,1-1.59,1.81,1.65,1.65,0,0,1-1.89-1.43,1.72,1.72,0,0,1,1.58-1.81A1.68,1.68,0,0,1,285.12,126.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.05,122c-.2.23-1.58-.64-3.46-.53s-3.21,1.1-3.43.89.09-.51.67-1a4.93,4.93,0,0,1,2.72-1,4.76,4.76,0,0,1,2.78.71C283.93,121.51,284.15,121.9,284.05,122Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.68,135.18a13.36,13.36,0,0,1,3-.7c.47-.08.92-.2,1-.52a2.35,2.35,0,0,0-.41-1.37l-1.63-3.47c-2.27-5-3.94-9-3.74-9.13s2.22,3.86,4.49,8.81l1.57,3.5a2.69,2.69,0,0,1,.36,1.82,1.2,1.2,0,0,1-.75.73,3.4,3.4,0,0,1-.81.16A12.36,12.36,0,0,1,291.68,135.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11,114.81c-.15.5-2.05.37-4.24.76s-3.94,1.06-4.26.63c-.14-.2.14-.69.83-1.21a7.64,7.64,0,0,1,6.48-1.06C283.75,114.2,284.18,114.57,284.11,114.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.52,115.37c-.3.44-1.63.08-3.19.14s-2.86.44-3.19,0c-.14-.21,0-.64.59-1.06a4.56,4.56,0,0,1,2.55-.83,4.48,4.48,0,0,1,2.59.7C301.45,114.74,301.66,115.16,301.52,115.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.31,109.26s-3.67-7.27-7.47-8.8c-4.6-1.86-6.24,3-10.58,2.11s-8.72-2.71-12.89.74c-4.57,3.78-2.19,6.11-2.17,11.41.07,21.48-3.59,27.76-5.33,17.74-.19-1.1-3.4-1.8-4.14-6.45-1-6-1.64-13.35-.5-17.72.95-3.69,2.93-6.31,6.57-9.28,5.76-4.69,14-5.25,19.65-5S303.27,99.9,303.31,109.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.63,132.09a3.31,3.31,0,0,0-3.77-2.91c-2.27.34-4.74,1.74-4.32,6.32.75,8.12,9,5.71,9,5.48S266,135.49,265.63,132.09Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.42,138.08s-.14.11-.37.24a1.5,1.5,0,0,1-1.09.12c-.91-.24-1.78-1.54-2-3a4.65,4.65,0,0,1,.22-2.06,1.7,1.7,0,0,1,1-1.18.74.74,0,0,1,.89.31c.14.22.1.39.14.4s.17-.15.07-.48A.9.9,0,0,0,263,132a1.15,1.15,0,0,0-.83-.14,2,2,0,0,0-1.4,1.39,4.73,4.73,0,0,0-.3,2.31c.21,1.63,1.21,3.09,2.45,3.32a1.56,1.56,0,0,0,1.31-.33C264.42,138.28,264.45,138.09,264.42,138.08Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,100.46c-1.29-.94-3.06-1.08-4.33-2-2.33-1.73-2.43-5.67-5.16-6.7-1.62-.61-3.44.14-5.16,0-2.8-.29-3.88-2.34-8.12-2.35-5.51,0-7.28,4-7.28,4a6.54,6.54,0,0,0-6.35.58A6.78,6.78,0,0,0,266,98.84s-.87-.43-3.52,1.6c-1.68,1.3-3.06,4.08-3.67,6.08-.91,3,.42,6.12,1.73,9,.7,1.53,1.58,3.22,3.22,3.76,2,.65,4.19-.86,5-2.77s2-3.82,3-5.65c1.65-3.18,3.33-6.14,1.95-8.18a9.86,9.86,0,0,1,5.89,0c1.91.61,3.59,1.81,5.5,2.47s4.32.61,5.61-.89a4.17,4.17,0,0,0,6.29,1.32,5.81,5.81,0,0,0,7.49,2.06C306.93,106.12,307.39,102.14,305.09,100.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.73,113.57a9.35,9.35,0,0,1,1,1.86,4,4,0,0,0,1.38,1.65,3.77,3.77,0,0,0,2.59.29,6.52,6.52,0,0,0,2.51-1,9.78,9.78,0,0,0,1.63-1.54,15,15,0,0,1,1.4-1.58,7,7,0,0,1-1.12,1.8,8.81,8.81,0,0,1-1.64,1.67,6.32,6.32,0,0,1-2.69,1.15,3.5,3.5,0,0,1-4.38-2.27A8.13,8.13,0,0,1,259.73,113.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,119.85a7.54,7.54,0,0,0,1.66.89,4.72,4.72,0,0,0,2,.16,5.83,5.83,0,0,0,2.3-.85,11.1,11.1,0,0,0,3.14-3.22,9.28,9.28,0,0,1,1.14-1.54,6.1,6.1,0,0,1-.84,1.72,9.91,9.91,0,0,1-3.18,3.45,5.9,5.9,0,0,1-2.51.89,4.73,4.73,0,0,1-2.17-.29A2.64,2.64,0,0,1,260,119.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.34,138.18a10,10,0,0,0-.47,2.73,3.05,3.05,0,0,0,.91,2.4,3.56,3.56,0,0,0,2.71,1.22h0a3.89,3.89,0,0,0,3.86-3.23l.33-2C291.74,138.76,286.49,138.31,286.34,138.18Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,144s-.25,0-.67.06a6,6,0,0,1-1.77,0,3.52,3.52,0,0,1-2.15-1.23,4.08,4.08,0,0,1-.85-2.85,4.2,4.2,0,0,1,.45-1.65l-.26.12c1.88.28,3.53.5,4.71.63a7.87,7.87,0,0,0,1.89.13,9.63,9.63,0,0,0-1.84-.44c-1.17-.22-2.8-.5-4.68-.8l-.18,0-.08.16a4.62,4.62,0,0,0,.48,5,3.75,3.75,0,0,0,2.46,1.27,4.89,4.89,0,0,0,1.86-.17A1.81,1.81,0,0,0,291.49,144Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65,268.16l-27-23.11-3,29.52,53.1,39.09,18.37-2.37,14.66-6.57s30.62-41.67,30.62-44.51l-12.18,4.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65,268.16c.56,1.65,41.91,41.27,41.91,41.27L268,336.55S220.23,295,212.09,288.63s-18.86-19.05-19.71-27.39,10.35-19.34,10.35-19.34,11,0,17.2,2S250.65,268.16,250.65,268.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.32,330.24c.63-3.38,1.31-6.86,3.16-9.76s5.18-5.13,8.59-4.65c2.27.32,4.24,1.76,6.47,2.28s4.46.13,6.71.1,6.08,0,7.49,1.71l16.72,11.42c-5.15,3.63-13.94,4-20.18,4.89s-12.61,1.3-18.55,3.41c-2.58.92-5.48,2.14-7.93.9a6,6,0,0,1-2.94-4.63A17.81,17.81,0,0,1,239.32,330.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,339.67a3.74,3.74,0,0,1-.06-1c0-.64,0-1.58,0-2.73a37.82,37.82,0,0,1,1.27-8.94,18.83,18.83,0,0,1,4.39-7.87,12.64,12.64,0,0,1,2.12-1.76,3.65,3.65,0,0,1,.88-.48,30.47,30.47,0,0,0-2.73,2.49,20,20,0,0,0-4.16,7.77,44.44,44.44,0,0,0-1.4,8.81A28.82,28.82,0,0,1,241,339.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.33,336.86c-.16,0,.7-2.91,1.18-6.54s.45-6.62.6-6.62a6.28,6.28,0,0,1,.2,2,30.61,30.61,0,0,1-.28,4.73,31,31,0,0,1-1,4.64A6.34,6.34,0,0,1,255.33,336.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.24,334.26c-.15-.07.81-2.08,1.25-4.76s.22-4.89.38-4.91a13,13,0,0,1-1.63,9.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.65,329.74s.37-.23,1-.67a8.88,8.88,0,0,0,2.25-2.27,8.14,8.14,0,0,0,.55-.91,4.22,4.22,0,0,0,.4-1,.55.55,0,0,0-.42-.71,1.94,1.94,0,0,0-1.15.2,4,4,0,0,0-1.91,1.83A4.27,4.27,0,0,0,267,329a5.38,5.38,0,0,0,3.7,3.95,4.15,4.15,0,0,0,1.21.25c.35,0,.38-.26.14-.55a13.07,13.07,0,0,0-1.75-1.31,35.5,35.5,0,0,0-4-2.05,4.24,4.24,0,0,1,1.16.32,16.43,16.43,0,0,1,3,1.42,12.35,12.35,0,0,1,1.89,1.34.91.91,0,0,1,.26.76.74.74,0,0,1-.68.52,4,4,0,0,1-1.4-.24,6.38,6.38,0,0,1-2.55-1.51,5.5,5.5,0,0,1-1.52-2.8,4.82,4.82,0,0,1,.42-3.16,4.53,4.53,0,0,1,2.18-2,2.31,2.31,0,0,1,1.45-.2,1,1,0,0,1,.64.47,1.12,1.12,0,0,1,.1.75,4.25,4.25,0,0,1-.48,1.14,7.21,7.21,0,0,1-.6.94,8.23,8.23,0,0,1-2.44,2.23A3.19,3.19,0,0,1,266.65,329.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.86,304.25s48.78-36.95,56.73-43.45,28-19.59,35.89-2.76-2.62,22.33-7.14,30.45-32.15,31.14-43.09,38.35c-8.83,5.82-24.88,5.82-24.88,5.82l-11.17,7.73L265.26,315.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,319.34c3.23-2.36,5.64-4,8.1-3s4.13,3.35,5.33,5.73a58.2,58.2,0,0,1,3.53,9.92c.88,3.05,1.62,6.73-.52,9.07a6.32,6.32,0,0,1-5.74,1.62,18.47,18.47,0,0,1-5.73-2.36c-5.45-3-17.36-7.69-22.81-10.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.34,318.17s.26.25.65.76.92,1.28,1.53,2.26a40.62,40.62,0,0,1,3.82,8.14,42,42,0,0,1,1.32,4.79,21.57,21.57,0,0,1,.55,4,6,6,0,0,1-.52,2.71,2.08,2.08,0,0,1-.58.83,6.51,6.51,0,0,0,.73-3.53,24,24,0,0,0-.65-3.93c-.34-1.47-.78-3.07-1.34-4.72a49.33,49.33,0,0,0-3.65-8.13C329.07,319.39,328.27,318.21,328.34,318.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,333.53a11.42,11.42,0,0,1,0-9.61,40.2,40.2,0,0,0-.52,4.81A39.54,39.54,0,0,0,320.34,333.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,331.2a3.34,3.34,0,0,1-1.14-2.28,3.43,3.43,0,0,1,.3-2.55c.15,0,0,1.14.21,2.46S314.11,331.12,314,331.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.78,263.83l-.32.27-1,.76-3.72,2.93-13.9,10.84L265.41,315.4l0-.36,14,17.64,6,7.55-.36-.05,9.77-7.15h0l0,0a146.69,146.69,0,0,0,15.76-7.62c4.93-2.72,9.52-5.54,13.76-8.39a138,138,0,0,0,11.51-8.67c3.49-2.84,6.72-5.47,9.63-7.9,5.82-4.84,10.35-8.87,13.4-11.71,1.53-1.42,2.69-2.53,3.47-3.29l.9-.85.31-.28s-.09.11-.28.31l-.86.89c-.77.78-1.91,1.91-3.42,3.35-3,2.89-7.52,7-13.31,11.84-2.9,2.44-6.11,5.09-9.59,7.95a137,137,0,0,1-11.51,8.72c-4.24,2.87-8.84,5.72-13.77,8.45a147.77,147.77,0,0,1-15.81,7.68l.05,0-9.76,7.15-.2.14-.16-.19c-2-2.49-4-5-6-7.55l-14-17.65-.16-.2.2-.15,47.58-36.63,14-10.72,3.77-2.86,1-.73A3.46,3.46,0,0,1,331.78,263.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.51,267.34c.1-.1,7.9,6.61,17.42,15s17.18,15.28,17.08,15.39-7.89-6.61-17.42-15S246.42,267.45,246.51,267.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.08,202.47c-.28-.17-4.91-5-3-11.29s4.9-9.92,6.55-12.39,3.85-9.42,5.34-9,2.81,1.62,2.74,4.12-4,7.26-2.56,9.71a2.2,2.2,0,0,0,3,.76s8.78-4.75,12.12-7.27,7-3.86,7.57-2.55.37,2.38-2.4,4.46-7.65,4.89-7.46,5.7,1.45.61,3.08-.58,9.69-6.25,10.83-5.7a2.08,2.08,0,0,1,.73,3.17l-1.45,1.84s2.09.8,1.73,2.21-2.64,2.42-2.64,2.42l-10.88,6.4s-.19,1,.4,1.25,8.56-5.6,9.22-4.75,1.66.81-.44,3-8.4,6.11-11.06,6.93-12.39,6.35-12.39,6.35Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.77,191.74c.1.19,3.75-1.33,8-3.62s7.55-4.49,7.44-4.67-3.57,1.69-7.84,4S386.67,191.54,386.77,191.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39,195c.05.06.81-.47,1.4-1.78a6.2,6.2,0,0,0-.25-5.4,15.71,15.71,0,0,0-1.83-2.39,8.52,8.52,0,0,1-1.29-1.9,7.14,7.14,0,0,1-.49-2c-.08-.06-.54.85-.05,2.24a7.55,7.55,0,0,0,1.25,2.15,21.52,21.52,0,0,1,1.7,2.31,6.28,6.28,0,0,1,.42,4.84C378.85,194.28,378.28,194.92,378.39,195Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77,219l12.55-22,11.9,11.15s-8.8,25.79-13.55,33.24-10.11,10.14-10.11,10.14-9.37-4.48-13.51-10.07-15-24.58-15-24.58l15.4-15.73Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.14,229.58a18.22,18.22,0,0,1-.23-5.76,18.44,18.44,0,0,1,1.1-5.66c.15,0-.35,2.55-.58,5.7S351.29,229.57,351.14,229.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.73,206.85s-9.86-20.41-15-29.06-24.07-10.11-24.07-10.11l10.65,48.22,5.42,5.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.38,197a20.85,20.85,0,0,1-.51,4.4c-.48,2.8-1.1,6.46-1.79,10.51s-1.29,7.7-1.77,10.51c-.2,1.26-.37,2.33-.51,3.19a5.79,5.79,0,0,1-.25,1.16,4.68,4.68,0,0,1,.05-1.19c.06-.76.18-1.86.35-3.21.34-2.71.91-6.44,1.62-10.55s1.41-7.81,1.94-10.49l.63-3.17A11.19,11.19,0,0,1,325.38,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.5,189.13c-.15,0,.45-2.95.66-6.61s0-6.63.13-6.65a6.2,6.2,0,0,1,.33,1.94,32.55,32.55,0,0,1,.06,4.74,33,33,0,0,1-.62,4.7A6.34,6.34,0,0,1,327.5,189.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.29,169.6s6.83,33.25,3.88,46.17l-1.76,31.31s5.41,15.84,4.63,18.08-21.3,21.28-38.86,20.16-30-12.71-31.52-13.83-8.18-5.32-8.18-5.32l1.11-13.94-1.3-45.88-3.15-34.69,20.51-5,4.25-6.18,23,19.31,7.58-19.31L300,166Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.57,251.67a16.35,16.35,0,0,0,2.28.84,11.59,11.59,0,0,0,6.51-.51,30.69,30.69,0,0,0,8.56-4.85,93.38,93.38,0,0,0,23.24-24.82c1.53-2.37,2.66-4.36,3.44-5.74l.88-1.59a2.86,2.86,0,0,1,.34-.54,3.43,3.43,0,0,1-.25.59l-.79,1.64c-.72,1.41-1.81,3.43-3.31,5.84a89.2,89.2,0,0,1-23.27,25,30.24,30.24,0,0,1-8.72,4.81,11.47,11.47,0,0,1-6.68.36,6.09,6.09,0,0,1-1-.35,4,4,0,0,1-.69-.35A3.06,3.06,0,0,1,264.57,251.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.21,182.54s-.21-.18-.54-.57l-1.39-1.71.23,0c-.78,1.49-1.78,3.51-3.16,5.95a1.44,1.44,0,0,1-1,.62,1.93,1.93,0,0,1-1.16-.36,16.88,16.88,0,0,1-1.73-1.53l-3.52-3.35c-3.79-3.61-7.19-6.9-9.64-9.29l-2.88-2.87a6.87,6.87,0,0,1-1-1.1,9.92,9.92,0,0,1,1.15,1l3,2.74c2.51,2.33,6,5.58,9.75,9.19l3.51,3.36a18.14,18.14,0,0,0,1.64,1.49,1,1,0,0,0,1.56-.13c1.35-2.31,2.46-4.39,3.29-5.81l.11-.19.12.17,1.29,1.79A3.75,3.75,0,0,1,289.21,182.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.42,167.64a4.28,4.28,0,0,1,0,1.11c-.06.7-.15,1.73-.37,3a41.65,41.65,0,0,1-2.79,9.53c-.52,1.22-1.09,2.38-1.66,3.44l-.27.52-.18-.55c-.94-2.79-1.73-5.2-2.27-6.9l.29,0a18.94,18.94,0,0,1-1.54,2.53,21.14,21.14,0,0,1,1.26-2.68l.17-.32.12.34c.62,1.68,1.47,4.07,2.44,6.85l-.46,0c.55-1.06,1.1-2.21,1.62-3.41a48.68,48.68,0,0,0,2.91-9.4C300.18,169.19,300.34,167.63,300.42,167.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.56,210.1l-15.62,19.79s3.11,6.52,3.88,8.6,13.78,22.66,13.78,22.66l-12.76,6.52s-20.3-18.49-26.8-26.05a17.66,17.66,0,0,1-3.95-14.87c1-4.95,23.62-32.15,23.62-32.15l14.53,1.69Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6,261.15s7.9,19.84,8.65,22.14,1.25,16.46.62,18.76-4.12,9.06-5.62,9.57-2.64,1.28-1.75-2.56a36,36,0,0,1,2.12-6.5l.25-7.66s-1.8,6-3.12,6.77-5.25-.64-5.25-.64v-1.28s-3.5.51-4-.76.45-3.66.45-3.66S232,299.24,230,298s-.38-2,0-4.6a29.11,29.11,0,0,0,0-9.05c-.58-3.29-1.5-5.62-1.88-7.78s.72-8.87.72-8.87l7.16-7.46Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.57,199.05s16.45-20.2,20.56-24.48,10.67-2.81,11.26-2.81,7.49,11,6.31,21.74A25.7,25.7,0,0,1,245.39,210l-10,12.48Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.93,291.61a22.35,22.35,0,0,1-2.55,9.28,43.62,43.62,0,0,1,1.28-4.64A43.44,43.44,0,0,1,239.93,291.61Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.76,289.19a12.71,12.71,0,0,1-1.61,8.21c-.14-.06.55-1.81,1-4.07S234.61,289.19,234.76,289.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.42,206a10.9,10.9,0,0,1,.65-1.38c.45-.88,1.1-2.15,1.83-3.75a33.1,33.1,0,0,0,3.43-13.14,18.8,18.8,0,0,0-1.3-7.32,14.56,14.56,0,0,0-8.05-8.15s.14,0,.39.09a7.91,7.91,0,0,1,1.08.39,12.52,12.52,0,0,1,3.49,2.35,15.26,15.26,0,0,1,3.53,5.14,18.83,18.83,0,0,1,1.38,7.51,31.61,31.61,0,0,1-3.61,13.29c-.79,1.58-1.49,2.83-2,3.68A8,8,0,0,1,247.42,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.17,219.81a8.17,8.17,0,0,1,1.65,1.64,24.82,24.82,0,0,1,5.07,9.94,7.28,7.28,0,0,1,.35,2.3,52.5,52.5,0,0,0-2.79-7.32A54.5,54.5,0,0,0,218.17,219.81Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.64,246.81a8,8,0,0,1-8.48,8.49c-.25,0-.49-.06-.74-.11-2.71-.5-5-2.29-7.14-4L403,241.34a27.86,27.86,0,0,1-5.23-5,9.33,9.33,0,0,1-2-6.8l.68-.17a12.77,12.77,0,0,1,10.44-6.23,16.62,16.62,0,0,1,11.6,4.32c2.2,1.95,3.93,4.37,6.15,6.31,0,0,4.25.49,5.7,4.4A35.65,35.65,0,0,1,431.64,246.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36,230.22a13.56,13.56,0,0,0-5.72-2.83,8,8,0,0,0-6.15,1.18c-1.63,1.17-2.62,3-3.76,4.63s-2.56,3.65-4.54,3.93a1.9,1.9,0,0,0-1,.37c-.45.43-.2.8.36,1.06a2.94,2.94,0,0,0,1.83,0,6.52,6.52,0,0,1-3.85,2.17,2.82,2.82,0,0,0,3.46,2,28.83,28.83,0,0,0-1.14,7.06,9.77,9.77,0,0,0,2.31,6.61c1.78,1.93,4.69,3,5.48,5.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.6,314.5l-32-.42,3.57-27.22s-2.19-.46-2.33-12.31-.69-32-.69-32h0a41.13,41.13,0,0,1,41.35,5.2l1.76,1.35Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.58,263.7c.2-.08,8.14-2.4,7.88,5.69s-8.34,6.17-8.34,5.94S423.58,263.7,423.58,263.7Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.55,262c-.2-.08-7.42-2-7.16,6.07s8.33,6.16,8.34,5.93S385.55,262,385.55,262Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.2,262.8c-1.21,6.78-1,10.35-2.09,14.88-1.77,7.17-5.33,12.67-11.79,16.25s-15.2,3.52-20.75-1.36c-3.85-3.38-6.58-7.2-7.15-12.3s-2.07-14.66-2.11-19.79c-.06-9.24.25-17.53.25-17.53L409,238.17l15,8.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,298c0,.19,2,.7,4.63.41S408.1,297.2,408,297s-2,.41-4.51.67S399,297.81,399,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.93,274.33c.77-6.95,1.27-14.9,2.36-22.23.41-2.75,1.39-6.72,1.14-9.49s-1-1.93-2.23-4.44c-1.53-3.15-7.4-5.24-10.84-5.93s-3.85-3.66-6.49-1.35a8.57,8.57,0,0,0-15.63,3.61,6,6,0,0,0-9.82,6,5.82,5.82,0,0,0-3.93,8.91c1.22,1.88,3.43,2.92,4.78,4.72a6.77,6.77,0,0,1,.41,7.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.9,272.89c-.18-.05-.54,3.31.91,7.11s3.92,6.09,4,5.94-2-2.55-3.33-6.2S391.13,272.88,390.9,272.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.35,267c-.16-.08-1.19,2.8-.51,6.41s2.62,5.95,2.74,5.82-1.42-2.53-2-5.95S387.58,267,387.35,267Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.61,239a18.09,18.09,0,0,0-8.24-7.37c-3.48-1.39-7.76-1.1-10.61,1.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,256.91a6.6,6.6,0,0,1,.26-2.39,31.15,31.15,0,0,0,.61-5.61,12.57,12.57,0,0,0-1.21-5.37c-.64-1.27-1.28-1.93-1.17-2s.9.42,1.74,1.71a10.85,10.85,0,0,1,1.58,5.69,19.9,19.9,0,0,1-.91,5.77C420.42,256.1,420.07,256.94,420,256.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.49,259.59c-.24-.13.42-1.73,1.05-3.74s1-3.7,1.3-3.67.27,1.84-.41,3.95S414.7,259.72,414.49,259.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.12,257.51a6.88,6.88,0,0,1-1.81-2.89,14.3,14.3,0,0,1,3.09-15.5c1.52-1.51,2.74-2.07,2.79-2s-1,.87-2.3,2.43a15.21,15.21,0,0,0-3,14.82C388.56,256.33,389.25,257.43,389.12,257.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,227.39a12,12,0,0,1-2.61-1.1,15.3,15.3,0,0,0-6.36-1.56,7.69,7.69,0,0,0-5.78,2.43,18.06,18.06,0,0,0-1.48,2.31c-.1,0-.13-1.22,1-2.73a7.06,7.06,0,0,1,2.46-2.06,8.69,8.69,0,0,1,3.81-.89,13.34,13.34,0,0,1,6.68,1.91C417.22,226.58,418.05,227.28,418,227.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,234.89c-.1,0,.09-.94.94-2.14a8.73,8.73,0,0,1,10.29-3c1.36.56,2,1.22,1.94,1.3s-.84-.31-2.15-.67a9.3,9.3,0,0,0-9.57,2.78C382.42,234.17,382,235,381.88,234.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.59,264.65c0-.11,1.3-.47,3.43-1.42a27.53,27.53,0,0,0,7.82-5.29l1.53-1.48-.84,2a17.68,17.68,0,0,0-1.14,3.84c-.13.67-.24,1.51,0,1.62s.91-.16,1.51-.58a24.55,24.55,0,0,0,5.44-4.81l1.4-1.68-.64,2.09c-.64,2.09-1.24,4-1.78,5.8l-.61-.37c3.71-3.51,5-6.64,5.17-6.52a6.7,6.7,0,0,1-.91,2.11,21.9,21.9,0,0,1-3.75,4.94l-1,1,.38-1.35,1.64-5.84.77.4a24.1,24.1,0,0,1-5.61,5,7.86,7.86,0,0,1-1.05.6,1.53,1.53,0,0,1-1.53-.06,1.6,1.6,0,0,1-.52-1.4,9,9,0,0,1,.17-1.13,17.4,17.4,0,0,1,1.25-4l.7.49a25.22,25.22,0,0,1-8.22,5.14A11,11,0,0,1,390.59,264.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,233.43a4.12,4.12,0,0,0-2.56-2,7.12,7.12,0,0,0-3.28-.08,11.75,11.75,0,0,0-6.89,4c-.4.48-.75,1.21-.33,1.66a1.36,1.36,0,0,0,.91.31,50.79,50.79,0,0,0,11.94-.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.63,385s-24.26-13.9-32.33-13.45c-7.36.42-15.17,2.67-18.59,8.82s-2.64,15.46,1.31,21.07,43.64,37.33,44.17,38.64,15.69,19.3,46.55,19.45c30.64.15,47.77.36,50.4-3.59s4.34-46.62,4.34-46.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.5,356.63c-5.16-4.78-13.29-4.49-20.41-2.59-7.81,2.07-26.55,22.82-26.55,22.82l-8.07,81.08c15.95-5.26,24.9-26.48,28.48-32.11.76-1.2,29.84-42.2,31.85-48.76S486.66,361.42,481.5,356.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,352.22s.2-26.42,5.56-35.17,9.14-10.92,17.09-11.92,27.42-2,27.42-2l34.77,2.38s29-.43,29,7.15c0,1.39-10.71,35.86-10.71,100.53,0,.63,5.35,2.36,2.14,9.65-4.51,10.24-19.77,30.62-46.72,30.62-22.06,0-46.43-10.66-48.42-26.16s5.38-60.6,5.38-60.6v-15.1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.41,309s10.19,3,12.78,13.93,8.18,34.89,8.18,34.89l-28.71,2.39s-1.6-18.12-1.2-25.6S444.2,310.44,446.41,309Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.85,380.24a2,2,0,0,1-.21-.59c-.13-.48-.28-1-.47-1.74-.39-1.51-.93-3.71-1.57-6.43-1.27-5.43-3-13-4.62-21.33s-3-16-3.74-21.51c-.38-2.76-.62-5-.76-6.57-.05-.72-.09-1.31-.12-1.8a1.8,1.8,0,0,1,0-.63,2.91,2.91,0,0,1,.13.62c.07.48.15,1.07.24,1.78.22,1.55.54,3.78,1,6.53.87,5.51,2.27,13.1,3.93,21.45s3.26,15.9,4.42,21.36c.56,2.65,1,4.84,1.36,6.47.14.7.25,1.28.34,1.77A2.61,2.61,0,0,1,359.85,380.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.61,327.64a2,2,0,0,1,0,.65c-.06.49-.15,1.1-.24,1.83l-.95,6.75c-.76,5.71-1.66,13.61-2.39,22.36s-1.27,16.69-1.69,22.44c-.21,2.79-.39,5.09-.53,6.8-.07.73-.13,1.34-.18,1.84a2.17,2.17,0,0,1-.1.64,1.81,1.81,0,0,1,0-.65c0-.5,0-1.11.05-1.85.08-1.71.19-4,.31-6.81.3-5.76.75-13.7,1.49-22.47s1.71-16.67,2.6-22.36c.44-2.85.84-5.15,1.16-6.73.14-.73.27-1.33.37-1.82A2.4,2.4,0,0,1,445.61,327.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,430.55a9.88,9.88,0,0,1-2,0,15.65,15.65,0,0,1-2.29-.16,26.53,26.53,0,0,1-3-.44,30.77,30.77,0,0,1-3.59-.86,40.89,40.89,0,0,1-4-1.38A42.66,42.66,0,0,1,361,416.59a40.79,40.79,0,0,1-2.64-3.33,30.42,30.42,0,0,1-2-3.1,26.83,26.83,0,0,1-1.43-2.69,17.4,17.4,0,0,1-.91-2.11,9.77,9.77,0,0,1-.63-1.86c.14-.06,1,2.6,3.38,6.41a32.37,32.37,0,0,0,2,3c.75,1.08,1.7,2.12,2.66,3.24a43.8,43.8,0,0,0,15.55,11c1.38.53,2.67,1.07,3.94,1.42a32.67,32.67,0,0,0,3.53.93C388.83,430.44,391.64,430.4,391.63,430.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.44,411.58q-3.07-6.9-6.17-13.81a4.82,4.82,0,0,0,3.9,1.56c1.52-11.49,2-20.19-2.95-30.65,2.27,20.06-5.76,40.38-14.51,57.49,2.69.11,6.19-5.37,7.38-7.79s3.5-5.11,6-4.16c2,.77,3.2,3.74,5.34,3.35a2.7,2.7,0,0,0,1.92-2.63A7.77,7.77,0,0,0,362.44,411.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M361,405.35c-.14.13-2-1.82-3.69-4.71s-2.63-5.35-2.48-5.43,1.45,2.26,3.07,5.09S361.11,405.22,361,405.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.73,415.08a2.81,2.81,0,0,1-.28.76c-.22.49-.49,1.23-1,2.13a46.52,46.52,0,0,1-4.5,7.29,49.22,49.22,0,0,1-8.84,9.14,49.6,49.6,0,0,1-41.46,9.71,46.32,46.32,0,0,1-8.18-2.55c-.95-.37-1.64-.75-2.12-1a3.84,3.84,0,0,1-.71-.39,4,4,0,0,1,.77.26c.5.18,1.2.53,2.16.85a51.71,51.71,0,0,0,20.73,3.25,48.88,48.88,0,0,0,28.42-10.64,51.14,51.14,0,0,0,8.85-8.95,52.25,52.25,0,0,0,4.65-7.13c.5-.87.81-1.59,1.07-2A3.45,3.45,0,0,1,438.73,415.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.16,362.91c0,.07-1.15-.58-3.33-1.28a26.67,26.67,0,0,0-9.59-1,50.43,50.43,0,0,0-14,3.2c-5.13,1.77-10.65,4.21-16.83,5.65a37.82,37.82,0,0,1-9.18,1.07,24.85,24.85,0,0,1-8.47-1.59c-5.16-2-9-5.19-12.39-7.56a60.08,60.08,0,0,0-8.19-5.25c-2.05-1-3.28-1.4-3.25-1.48a5,5,0,0,1,.89.26,21.79,21.79,0,0,1,2.48,1,55.13,55.13,0,0,1,8.35,5.1c3.38,2.33,7.29,5.41,12.33,7.36s11.22,1.9,17.28.45,11.61-3.83,16.78-5.58a49.39,49.39,0,0,1,14.17-3.09,25.69,25.69,0,0,1,9.69,1.26,18.35,18.35,0,0,1,2.45,1.06A5.39,5.39,0,0,1,440.16,362.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.55,352.15v27.51s-7,17.48-9.64,28-9.63,37.26-9.63,37.26l9.63,8.56s16.76-32.27,21-43a126.53,126.53,0,0,0,6.13-20.05A75.59,75.59,0,0,0,358,377.17c.1-6.06-4.67-25-4.67-25Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.06,458.92s9.5-9.83,10-9.72,15.33-2.7,15.33-2.7l10.48-.87,2.74-1,9.46,8.6s-1.19,4.54-3.89,5.29-14.25,1.3-14.25,1.3l-3.67-1-4.1.32s-6.38,3.24-7.67,3.24a6.69,6.69,0,0,1-2.7-.76s-.22-1.18,1.94-2.48l3.78-2.27-9.5,4.22-8-.22Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.36,453.77c0,.11-1.07.06-2.73.41a37,37,0,0,0-6.31,2,42.4,42.4,0,0,0-5.93,3c-1.45.89-2.25,1.58-2.32,1.51a7,7,0,0,1,2.05-1.91,30.25,30.25,0,0,1,5.94-3.22,27.55,27.55,0,0,1,6.49-1.88A5.88,5.88,0,0,1,310.36,453.77Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,449.94a16.58,16.58,0,0,1-3.56.82c-2.19.46-5.13,1.54-8.42,2.5l-.45.14.1,0c-2.64,2-4.95,3.93-6.64,5.27a19.06,19.06,0,0,1-2.81,2.1,17.25,17.25,0,0,1,2.5-2.46c1.62-1.44,3.87-3.41,6.54-5.45l0,0h.05l.45-.14a80.43,80.43,0,0,1,8.54-2.33A22.66,22.66,0,0,1,305.09,449.94Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.15 359.64 451.9 403.43 486.1 456.64 494.04 447.24 471.92 393.55 466.29 357.8 442.15 359.64",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.44,457.78l-18.09-10.52L492,446.63l-5.88,9.79s1.81,2.49,7.24,2.72,10,0,10,0,7.91,3.84,9.49,2.71a8,8,0,0,1,3.17-1.36s5.65,3.36,6.55,1.57a6.78,6.78,0,0,1,2.94-2.7Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.17,454.45a7.39,7.39,0,0,1,2.4-.41,11.74,11.74,0,0,1,2.67.08,7,7,0,0,1,3.07,1.25c3.56,2.92,6.2,5.44,6.1,5.58s-3-2.18-6.49-5a9,9,0,0,0-5.34-1.41A10.56,10.56,0,0,1,500.17,454.45Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.23,450.46a2.38,2.38,0,0,1,1-.11,12.24,12.24,0,0,1,2.61.25,24.75,24.75,0,0,1,7.95,3.36c2.86,1.76,5.34,3.49,7.25,4.55s3.14,1.6,3.1,1.7a11,11,0,0,1-3.33-1.28c-2-1-4.54-2.65-7.37-4.39a29,29,0,0,0-7.7-3.48C503.6,450.53,502.23,450.58,502.23,450.46Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M438.73,415.08a29.55,29.55,0,0,1-8.5,17c-7.7,7.54-14.53,12.26-25,14.74s-24.84,2-31.89-6.18c0,0,18.37,7.3,33.69,2.32C431.21,435.11,438.73,415.08,438.73,415.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M384,231.67c-1.05,1.56-2,3.29-3.64,4.26a25.35,25.35,0,0,1-2.79,1.18,4,4,0,0,0-2.23,1.95,1.92,1.92,0,0,0,.93,2.53,3.24,3.24,0,0,0-1.93,3.28,4.36,4.36,0,0,0,2.21,3.26,6.84,6.84,0,0,0,4,.8l7.82-20.66C386.49,228.54,385.1,230.11,384,231.67Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.58,361.8l16.49,37.25,46.46-20.27c-2.21-4.32-30.13-2.74-30.13-2.74l-9.59-24.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.15,380.29a2.07,2.07,0,0,0-.36,2.74,2,2,0,0,0,2.71.39,2.19,2.19,0,0,0,.37-2.9,2.05,2.05,0,0,0-2.86-.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.07,399.05l-1.51-3.82,45.11-18s2.46,0,2.86,1.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.05,375.47c.09.23-1,.83-1.8,2s-1,2.43-1.22,2.43-.49-1.46.51-2.92S208,375.24,208.05,375.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.8,375.36c.15.2-.67,1-1,2.31s-.13,2.41-.36,2.49-.94-1.13-.47-2.73S213.7,375.15,213.8,375.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.11,380c-.18.14-1-.85-1-2.35s.88-2.45,1.06-2.31-.19,1.1-.2,2.33S219.33,379.86,219.11,380Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.25,370.17c0,.25-1.18.39-2.43,1s-2.07,1.49-2.27,1.35.41-1.38,1.88-2.12S205.28,370,205.25,370.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.73,365.15a4.76,4.76,0,0,1-2.33,1,11.11,11.11,0,0,1-2.76.31,11.74,11.74,0,0,1-1.64-.12,3.17,3.17,0,0,1-.94-.24,1.08,1.08,0,0,1-.64-1.16,1.41,1.41,0,0,1,.77-1,3.46,3.46,0,0,1,.93-.26,9.07,9.07,0,0,1,4.42.34c1.51.53,2.25,1.21,2.19,1.29s-.9-.36-2.36-.7a10,10,0,0,0-2.58-.27,10.25,10.25,0,0,0-1.52.17c-.55.09-1,.27-1,.54,0,.11,0,.14.17.24a2.24,2.24,0,0,0,.69.17,12.13,12.13,0,0,0,1.53.17,13.5,13.5,0,0,0,2.63-.12A16.11,16.11,0,0,1,201.73,365.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58,365.6c-.06.07-.87-.55-1.59-2a8.22,8.22,0,0,1-.8-2.69,8.41,8.41,0,0,1,0-1.67,2.09,2.09,0,0,1,1-1.82,1.17,1.17,0,0,1,1.25.23,3.38,3.38,0,0,1,.62.74,5.92,5.92,0,0,1,.74,4.41c-.39,1.6-1.21,2.28-1.27,2.21a18.48,18.48,0,0,0,.67-2.32,5.88,5.88,0,0,0-.22-2.51,5.14,5.14,0,0,0-.63-1.32c-.29-.47-.65-.78-.81-.65s-.46.64-.48,1.12a8.54,8.54,0,0,0,0,1.51,9.18,9.18,0,0,0,.57,2.52C201.08,364.77,201.69,365.51,201.58,365.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,279.3c-2-.94-11-2.47-20.28,3.64-27.69,18.25-72.45,60.14-72.45,60.14L74,352.55l46.43,2.79,32.63-31.29,26.77,56.41c-.59-.68,30.23-12.35,30.23-12.35S178.65,284.55,167.47,279.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,356.69c-2.1-.67-5.87-1.23-12.84-2.15-16.31-2.16-42-6.11-42-6.11L34.42,345l-4,19.37c-1.35,17.15,8.74,23.8,16.4,25.75,19,4.82,61.32,7,76.47,8.29,22,1.84,35.34-6.42,37-16.11C163.47,363.93,149.43,360,139,356.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,361.45a3.82,3.82,0,0,1-.56-.31c-.37-.21-.88-.56-1.6-.92a36.87,36.87,0,0,0-6.21-2.66,46.65,46.65,0,0,0-9.81-2.09c-3.76-.55-7.87-1.21-12.19-1.91-8.64-1.42-16.48-2.6-22.18-3.22-2.85-.32-5.16-.52-6.75-.66l-1.84-.16a3,3,0,0,1-.64-.08h.64l1.85.08c1.6.1,3.92.26,6.77.54,5.72.55,13.57,1.68,22.21,3.1l12.18,1.95a45.27,45.27,0,0,1,9.84,2.18,34.21,34.21,0,0,1,6.21,2.79c.7.39,1.21.76,1.56,1A3.91,3.91,0,0,1,149,361.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.18,298.94a5.06,5.06,0,0,1-.31,1c-.23.62-.55,1.51-.91,2.63a59.54,59.54,0,0,0-2.18,8.89,61.4,61.4,0,0,0-.75,9.12c0,1.17,0,2.12,0,2.78a4.72,4.72,0,0,1,0,1,5.21,5.21,0,0,1-.14-1c-.07-.66-.12-1.61-.15-2.79a50.74,50.74,0,0,1,2.93-18.1c.4-1.11.76-2,1-2.59A6.19,6.19,0,0,1,157.18,298.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.35,351.73a7.07,7.07,0,0,1-1.45-1.79,6.91,6.91,0,0,1-1.14-2,7.35,7.35,0,0,1,1.45,1.79A7.53,7.53,0,0,1,109.35,351.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6,238.83s6.07-3.25,17.07,3c11.84,6.72,58.94,28.56,58.94,28.56s7.64,19.42,8.9,38.08c.6,9,.12,12,.12,12l-13.83-.59s-11.67-36.39-16.34-39.14l-44-10.37Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.39,343.47s-1.42,3.63-.5,4.31,1.54,1.66,3.15,0,3.28-3.48,3.28-3.48a3.62,3.62,0,0,0,2.2,1.71c1.36.21.09.42-.19.56s-3.84,1.84-4,3.78,1.07,1.51,1.07,1.51l8.55-2.78s-2,2.75.37,4.44l8.51-7.5,4.93-15.38,1.08-12.34-14.9.9c.8,0-6.73,7.7-7.65,8.94s-2.73,7.42-2.73,7.42",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,336.39a22.46,22.46,0,0,1-1.39,3.77,22.07,22.07,0,0,1-1.73,3.62,21.26,21.26,0,0,1,1.38-3.76A21.53,21.53,0,0,1,159.52,336.39Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5,339.58a10.57,10.57,0,0,1-1.51,2.61,10.73,10.73,0,0,1-1.94,2.33,14.76,14.76,0,0,1,1.63-2.53A15.55,15.55,0,0,1,165.5,339.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7,340.25a4.08,4.08,0,0,1-.38,1.2,7.79,7.79,0,0,1-1.64,2.61,8.55,8.55,0,0,1-2.62,1.68,4.4,4.4,0,0,1-1.23.43,4.77,4.77,0,0,1,1.11-.66,10.55,10.55,0,0,0,2.47-1.7,9.47,9.47,0,0,0,1.67-2.46A4.85,4.85,0,0,1,170.7,340.25Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.39,342.24a3.44,3.44,0,0,1-.29,1.43,8.61,8.61,0,0,1-1.89,3,8.91,8.91,0,0,1-3,2,3.93,3.93,0,0,1-1.45.39,13.35,13.35,0,0,1,1.33-.62,10.48,10.48,0,0,0,2.81-2.06,9.92,9.92,0,0,0,1.91-2.86C176.2,342.77,176.33,342.23,176.39,342.24Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.36,320.44s4.06-55.37,8.13-64.18c5.38-11.64,22.51-19.88,30.83-21,10.08-1.41,32,1.91,32,1.91l14.51,31.29-11.22,77.75c2.56,1,3.31,3.15,2.72,6.06L74,348.89a63.07,63.07,0,0,0-31,4.91l-11.26,4.89s-3-1.63-3.5-3.71,1-6.78,5.1-7.38l-.73.33Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.89,254.05l-6.44,27.27-25.21-6.54L92.71,236a107.26,107.26,0,0,1,18.13,2.41c3.71.9,13.66,3.72,13.66,3.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,305.11a7.82,7.82,0,0,1-.81,1l-2.32,2.63c-2,2.23-4.6,5.36-7.36,8.93s-5.14,6.91-6.81,9.36l-2,2.9a6.24,6.24,0,0,1-.77,1,5.77,5.77,0,0,1,.6-1.15c.41-.72,1-1.74,1.83-3,1.6-2.51,3.93-5.89,6.7-9.48s5.48-6.68,7.5-8.85c1-1.09,1.85-1.95,2.45-2.53A5.71,5.71,0,0,1,100.82,305.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2,252.6c.15,0-.81,8.13-2.14,18.11s-2.52,18.06-2.66,18,.81-8.13,2.14-18.11S121.06,252.58,121.2,252.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.85,287.31s44.91,28.5,51.52,29c14.31,1.15,41.12-37.52,41.12-37.52l-8.64-10.3s-29.87,22.86-32,22.69c-4.24-.33-34.57-22.79-34.57-22.79Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,268.73s3-9.61,4.71-11c.63-.53,1.51-1.33,2.38-2.12a5.29,5.29,0,0,1,6.17-.71l1.22.69s2.76-1.23,3.69-.27a26.34,26.34,0,0,1,2.39,3.53,8,8,0,0,1,3.45,1.38,11.19,11.19,0,0,1,1.66,1.52s2.38.8,3,2.52l.64,1.72s2.09,1.72,1.82,3.71-.88,1.26-.88,1.26l-2.11-.06s-12.79,7.11-15.39,7.58a18.56,18.56,0,0,1-4.25.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2,271.11a3.41,3.41,0,0,0-.77-.13,12.05,12.05,0,0,0-2.29.18h0c-1.63,1-4,2.33-7,4-1.52.81-3.18,1.69-5.05,2.51a9.58,9.58,0,0,1-1.48.53c-.52.12-1.05.2-1.58.29-1.08.18-2.18.33-3.33.44l.12-.07c-3.24,4.27-6.94,9.15-11.05,14.14-3.63,4.39-7.25,8.45-10.76,11.92-1.75,1.75-3.47,3.34-5.12,4.8a35.55,35.55,0,0,1-5,3.54,28.9,28.9,0,0,1-4.48,2.33,13.24,13.24,0,0,1-3.7.9,6.41,6.41,0,0,1-2.4-.22,3.65,3.65,0,0,1-.58-.24l-.19-.11a6,6,0,0,0,3.15.43,13.9,13.9,0,0,0,3.65-1,29.42,29.42,0,0,0,4.41-2.37,34.88,34.88,0,0,0,4.92-3.55c1.63-1.46,3.35-3.05,5.08-4.8,3.49-3.48,7.1-7.54,10.72-11.92,4.11-5,7.81-9.85,11.07-14.1l.05-.06h.07c1.13-.11,2.24-.25,3.31-.41.53-.09,1.06-.17,1.56-.28a10.12,10.12,0,0,0,1.43-.51c1.85-.8,3.53-1.67,5.05-2.46,3-1.59,5.44-2.93,7.09-3.84h0a10.55,10.55,0,0,1,2.32-.11,2.58,2.58,0,0,1,.59.11Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93,258.81a7.25,7.25,0,0,1-1-1.36c-.27-.45-.67-.91-1.05-1.46a1.91,1.91,0,0,0-1.79-.81,11.68,11.68,0,0,0-2.17.31,4.23,4.23,0,0,0-1.6.69,9.19,9.19,0,0,1-1,.73c-.26.14-.41.19-.42.17s.5-.37,1.26-1.1a4,4,0,0,1,1.67-.83,10.31,10.31,0,0,1,2.24-.34,2.2,2.2,0,0,1,2.07,1,16.55,16.55,0,0,1,1,1.54A7.45,7.45,0,0,1,163.93,258.81Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.38,259.26c0,.11-1-.23-2.32-.14s-2.23.55-2.29.45a4.34,4.34,0,0,1,4.61-.31Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.59,263.56c-.06,0-.25-.35-.77-.75a4.25,4.25,0,0,0-2.35-.83,10.09,10.09,0,0,0-2.56.29,3.51,3.51,0,0,1-1.09.18,3,3,0,0,1,1-.43,7.42,7.42,0,0,1,2.65-.42,4,4,0,0,1,2.51,1A1.65,1.65,0,0,1,171.59,263.56Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08,266.47c-.06,0-.11-.23-.37-.49a1.92,1.92,0,0,0-1.26-.53,4.4,4.4,0,0,0-1.44.27c-.37.11-.62.18-.64.13s.18-.19.54-.38a3.31,3.31,0,0,1,1.55-.4,1.9,1.9,0,0,1,1.46.74C173.17,266.18,173.12,266.48,173.08,266.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.27,300.88c-.11,0,0-2.17-.09-4.84s-.25-4.83-.14-4.84a19.64,19.64,0,0,1,.51,4.83A20.11,20.11,0,0,1,112.27,300.88Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59,254.78a8.07,8.07,0,0,0-.8.53,11.61,11.61,0,0,0-1.86,1.81c-1.51,1.64-2.4,4.62-3.75,7.72l-1.65,4,0,0,0,0c-1.85,1.42-3.43,2.63-4.56,3.47l-1.33,1a2.85,2.85,0,0,1-.5.32,2.26,2.26,0,0,1,.43-.41l1.26-1.06c1.1-.89,2.65-2.13,4.48-3.58l-.06.07,1.64-4,1.84-4.4a11.74,11.74,0,0,1,2-3.35A6.45,6.45,0,0,1,151.59,254.78Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.45,275.38c4.47,5.38,17.95,14.6,30.48,23.41L93.7,277.22s-27.19-27.68-34.45-29.17C52.94,246.76,36.9,247,41.45,275.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.85,278.79a3.12,3.12,0,0,1,.53.34l1.49,1.05,5.58,4L72.07,298.6l-.3,0L90.2,280.32,93.52,277v.37C88.07,272,82.6,267.14,77.78,262.64c-2.41-2.26-4.68-4.41-6.75-6.48a37.85,37.85,0,0,0-6.26-5.07,22.75,22.75,0,0,0-5.91-2.92,11.88,11.88,0,0,0-4.91-.34,8.85,8.85,0,0,0-3,1c-.63.34-.92.59-.93.57a4.51,4.51,0,0,1,.88-.66,8.89,8.89,0,0,1,3-1.1,11.92,11.92,0,0,1,5,.27,22.83,22.83,0,0,1,6,2.89,38.31,38.31,0,0,1,6.37,5.07c2.07,2.05,4.35,4.19,6.77,6.43,4.84,4.49,10.31,9.3,15.79,14.74l.18.19-.18.18-3.32,3.29L72.1,299l-.14.14L71.8,299,52.29,284.45l-5.51-4.15-1.44-1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.32,235.22l0-43.33c-.57-12.76,6.39-23.73,19.16-23.95l1.18.05a22.83,22.83,0,0,1,21.89,21.92c.44,11.07.77,23.31.46,29.22-.66,12.25-13,13.64-13,13.64s-.08,7.46-.07,11.06l-.23,8.77L72.32,235.22Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.05,232.77a29.59,29.59,0,0,1-15.76-5.37s3.46,9.37,15.73,8.77Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,200.48a1.74,1.74,0,0,1-1.76,1.7,1.67,1.67,0,0,1-1.73-1.65,1.74,1.74,0,0,1,1.75-1.7A1.67,1.67,0,0,1,111,200.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.75,195.22c-.22.21-1.51-.82-3.39-.89s-3.3.81-3.5.57.15-.51.77-.92a4.75,4.75,0,0,1,2.81-.74,4.56,4.56,0,0,1,2.69,1C111.69,194.7,111.87,195.12,111.75,195.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.74,200.48a1.74,1.74,0,0,1-1.76,1.7,1.69,1.69,0,0,1-1.74-1.65,1.76,1.76,0,0,1,1.76-1.7A1.67,1.67,0,0,1,93.74,200.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.28,194.89c-.23.22-1.51-.82-3.39-.89s-3.3.81-3.5.57.14-.51.76-.92a4.85,4.85,0,0,1,2.81-.74,4.7,4.7,0,0,1,2.69,1C93.21,194.37,93.39,194.79,93.28,194.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.44,209.64a11.83,11.83,0,0,1,3.08-.43c.48,0,.94-.11,1-.43a2.43,2.43,0,0,0-.26-1.44c-.4-1.18-.82-2.42-1.27-3.72-1.76-5.29-3-9.64-2.8-9.71s1.82,4.17,3.58,9.46c.42,1.31.82,2.55,1.21,3.74a2.82,2.82,0,0,1,.17,1.9,1.23,1.23,0,0,1-.82.67,3.59,3.59,0,0,1-.82.08A13,13,0,0,1,99.44,209.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.13,189c-.27.47-2.08-.12-4.3-.25s-4.09.12-4.3-.38c-.08-.24.31-.66,1.11-1a7.55,7.55,0,0,1,6.55.48C93.93,188.33,94.26,188.8,94.13,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.07,189.68c-.4.42-1.93-.06-3.77-.13s-3.41.19-3.76-.26c-.15-.22.11-.65.8-1a5.83,5.83,0,0,1,3.08-.62,5.74,5.74,0,0,1,3,.94C112.05,189,112.25,189.48,112.07,189.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,201c-.21-.1-8.32-2.84-8.39,5.55s8.35,6.73,8.37,6.49S73,201,73,201Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.43,209.85s-.15.1-.4.21a1.47,1.47,0,0,1-1.09,0c-.88-.34-1.61-1.75-1.64-3.26a4.68,4.68,0,0,1,.43-2.09,1.67,1.67,0,0,1,1.11-1.11.75.75,0,0,1,.86.41c.11.23,0,.4.09.41s.19-.14.12-.48a.92.92,0,0,0-.32-.53,1.1,1.1,0,0,0-.81-.22,2.07,2.07,0,0,0-1.54,1.28,5,5,0,0,0-.53,2.34c0,1.69.89,3.28,2.1,3.64a1.59,1.59,0,0,0,1.34-.21C70.41,210.05,70.46,209.87,70.43,209.85Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,210.8c.29,0,.3,1.91,2,3.27s3.7,1.14,3.72,1.41-.46.37-1.32.4a4.78,4.78,0,0,1-3.11-1.07,4.16,4.16,0,0,1-1.51-2.74C93.18,211.27,93.39,210.79,93.52,210.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,178.88a2,2,0,0,0-.92-1.17,6.09,6.09,0,0,0-3.13-.55,17.63,17.63,0,0,1-7.65-2,8.65,8.65,0,0,0,2.27-1.56,5.28,5.28,0,0,0,1.58-5.22,1.2,1.2,0,0,0-.65-.81c-.55-.17-1,.36-1.41.78a4.55,4.55,0,0,1-4.29,1.76,7.42,7.42,0,0,1-3.18-1L114,169c-.43-.45-.85-.89-1.27-1.31h0c-3.12-3.17-5.81-5.37-8.59-6.52-4.07-1.7-10.91-2.44-15.2-1.37s-8.15,4.49-8.8,8.86c-2.37-2-6-2.08-8.89-.94l-.07,0c-3.27,1.12-5.15,4.53-6.15,7.83l-.15.54a12.84,12.84,0,0,1-4.42,4.22c-.31.18-.68.4-.72.76a1,1,0,0,0,.55.87A6.42,6.42,0,0,0,62.93,183a14.38,14.38,0,0,1-1.1,2.27c-.37.61-.82,1.35-.5,2a1.36,1.36,0,0,0,1.42.64,3.77,3.77,0,0,0,1.52-.67l-1.11,2.59a7.67,7.67,0,0,0,3.53-.19c.66,3.1,1.11,8.85,1.88,10.95,2.23.07,2.77-.17,3.89.22,1.45.5.87,3.06,2.76,2.35,1-.36,2.49-4,2.82-5A47.92,47.92,0,0,0,80.35,178a15.33,15.33,0,0,1,4.79-3.38l-.15.13c3.45-1.15,7.34-2.28,10.57-.63,2.51,1.27,4,3.91,5.83,6a17.55,17.55,0,0,0,12.88,6.45c.44,3.71.52,9.77.66,13.22l3-6.88v0c.24-.4.44-.81.64-1.22l.06-.12h0a21.3,21.3,0,0,1,1-2l0,0a2.16,2.16,0,0,0,3.19-2.85,5.18,5.18,0,0,0-1-1.06,3.42,3.42,0,0,0,3.24.88A2.66,2.66,0,0,0,127,184a2.26,2.26,0,0,0-1.33-1.84,7.71,7.71,0,0,0,4.39-.92C130.93,180.77,131.79,180,131.51,178.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,170.11a9.83,9.83,0,0,0-1.24,1.11,8.72,8.72,0,0,0-1.93,4.06,14.78,14.78,0,0,0-.35,3.11c0,1.13.06,2.34.13,3.62a31.64,31.64,0,0,1,0,4,13,13,0,0,1-.3,2.12,4.4,4.4,0,0,1-.89,2.05,1.85,1.85,0,0,1-1.73.56,2.75,2.75,0,0,1-1.55-.9,6.31,6.31,0,0,1-1.15-3.13l.26,0a10.41,10.41,0,0,1-1.53,2.56,3.66,3.66,0,0,1-2.4,1.27,2.36,2.36,0,0,1-1.26-.24,2,2,0,0,1-.85-.85,2.16,2.16,0,0,1-.25-1.1,1.6,1.6,0,0,1,.4-.95l.13.12a7.81,7.81,0,0,1-2.66,1.95,6.76,6.76,0,0,1-.82.31l-.29.07a1.2,1.2,0,0,1,.28-.12c.18-.07.45-.18.79-.34a8.18,8.18,0,0,0,2.57-2l.13.11a1.58,1.58,0,0,0-.1,1.83,1.88,1.88,0,0,0,.77.76,2.17,2.17,0,0,0,1.14.2,3.44,3.44,0,0,0,2.23-1.21,10.23,10.23,0,0,0,1.47-2.5l.18-.4.08.43a6.07,6.07,0,0,0,1.09,3,2.44,2.44,0,0,0,1.39.81,1.54,1.54,0,0,0,1.47-.48,4.16,4.16,0,0,0,.83-1.92,14.93,14.93,0,0,0,.29-2.07,31.26,31.26,0,0,0,0-4c-.06-1.27-.13-2.49-.1-3.63a15.17,15.17,0,0,1,.39-3.16,8.74,8.74,0,0,1,2-4.08A5,5,0,0,1,84,170.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.86,182.49l-.1.08-.31.22a5.09,5.09,0,0,1-.53.33,7.38,7.38,0,0,1-.75.38,10.85,10.85,0,0,1-5.26.89,14,14,0,0,1-7.38-2.82,24.34,24.34,0,0,1-6.28-7.41c-.88-1.5-1.59-3-2.37-4.45a16.27,16.27,0,0,0-2.7-3.76,8.31,8.31,0,0,0-3.51-2.19,6.09,6.09,0,0,0-1.87-.24,6.73,6.73,0,0,0-1.71.31,7.05,7.05,0,0,0-2.57,1.51,7.24,7.24,0,0,0-1.41,1.78,8.17,8.17,0,0,0-.65,1.84s0-.05,0-.13,0-.23.06-.38a6,6,0,0,1,.48-1.38,7.12,7.12,0,0,1,4-3.43,6.62,6.62,0,0,1,1.76-.34,6.21,6.21,0,0,1,1.94.23,8.51,8.51,0,0,1,3.63,2.23,16.18,16.18,0,0,1,2.76,3.82c.8,1.42,1.51,2.95,2.38,4.43a23.85,23.85,0,0,0,6.19,7.34,13.82,13.82,0,0,0,7.23,2.83,11,11,0,0,0,5.21-.78C121.28,182.9,121.83,182.45,121.86,182.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,177.1s-.14.13-.44.31a10.07,10.07,0,0,1-1.31.64,12.35,12.35,0,0,1-2.07.66,15.14,15.14,0,0,1-2.64.32,15.77,15.77,0,0,1-2.66-.21,13.62,13.62,0,0,1-2.1-.57,10.2,10.2,0,0,1-1.33-.59,1.74,1.74,0,0,1-.46-.29c0-.05.7.31,1.86.69a15.19,15.19,0,0,0,2.08.5,16.25,16.25,0,0,0,2.6.18,15.52,15.52,0,0,0,2.59-.29,14,14,0,0,0,2.06-.59C122.35,177.44,123,177.06,123,177.1Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.ff7a524d93501545808dab25e1d5053b.svg";
export { ForwardRef as ReactComponent };